import * as THREE from "three"
import Experience from "../Experience.js"
import gsap from "gsap"
import TweenMax from "gsap"
import Data from "../data/data.json"

export default class PeriUrbain {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.sizes = this.experience.sizes
        this.debug = this.experience.debug
        this.camera = this.experience.camera
        this.canvas = this.experience.canvas
        this.controls = this.experience.camera.controls
        this.urbainRessource = this.resources.items.urbainModel
        this.ruralRessource = this.resources.items.ruralModel
        this.periRessource = this.resources.items.periModel

        this.vehicule = this.resources.items.vehiculeModel
        this.vehiculeUrbain = this.resources.items.vehiculeUrbain
        this.vehiculeRural = this.resources.items.vehiculeRural
        this.fluxUrbain = this.resources.items.fluxUrbain


        this.fluxRural = this.resources.items.fluxRural
        this.eolienne = this.resources.items.eoliennes
        this.killTl = false
        this.vehiculePeri = this.resources.items.vehiculeModelPeri
        this.indicator = this.resources.items.indicator
        // this.scene.add(this.indicator.scene)
        this.indicator.scene.children[0].material.blending = 2
        this.materialYellow = new THREE.MeshBasicMaterial({ side: 2, color: 0xFF6B35 })
        this.materialGrey = new THREE.MeshBasicMaterial({ side: 2, color: 0x525252 })
        this.materialBlue = new THREE.MeshBasicMaterial({ side: 2, color: 0x0068FF })
        this.materialBlueOpacity = new THREE.MeshBasicMaterial({ side: 2, color: 0x0068FF, transparent: true, opacity: 0.5 })
        this.materialYellowOpacity = new THREE.MeshBasicMaterial({ side: 2, color: 0xFFC900, transparent: true, opacity: 0.5 })
        this.flecheModel = this.resources.items.flecheModel




        this.zoomClick = true
        this.isView = false
        this.fluxfollower = 1
        this.menuClick = {
            0: false,
            1: false,
            2: false,
            3: false,
            4: false,
            5: false
        }
        this.body = document.querySelector("#bod")

        this.indicFollower
        // if (this.debug.active) {
        //     this.debugFolder = this.debug.ui.addFolder("POINT POSITION")
        //     this.debugFolder
        //         .add(this.indicator.scene.position, "x", -1000, 1000, 1)
        //         .name("Position X")
        //     this.debugFolder
        //         .add(this.indicator.scene.position, "y", -1000, 1000, 1)
        //         .name("Position Y")
        //     this.debugFolder
        //         .add(this.indicator.scene.position, "z", -1000, 1000, 1)
        //         .name("Position Z")


        // }
        this.cursor = new THREE.Vector2()
        this.textPlayerContent = document.querySelector("#textPlayerContent")

        window.addEventListener("mousemove", (event) => {
            ;
            (this.cursor.x = event.clientX),
                (this.cursor.y = event.clientY - innerHeight)
        })

        this.indicatorUrbain = {
            sob: [{
                    position: { x: 550, y: 0, z: -180 } //batimnet indus 2 cote gare
                },
                {
                    position: { x: -390, y: 0, z: -141 } //entrepot mutualise
                },
                {
                    position: { x: -347, y: 0, z: -13 } //prarking a etage
                },
                {
                    position: { x: -106, y: 0, z: -95 } //batiment mutualisé
                },
                {
                    position: { x: 150, y: 0, z: -135 } // entrepot
                }
            ],
            dur: [{
                    position: { x: 150, y: 0, z: -135 } // entrepot
                },
                {
                    position: { x: 472, y: 0, z: 266 } // electrolyseur
                },
                {
                    position: { x: -164, y: 0, z: -97 } // electrolyseur
                },
                {
                    position: { x: -167, y: 0, z: 139 } // electrolyseur
                },
                {
                    position: { x: 358, y: 0, z: -162 } // electrolyseur
                },
                {
                    position: { x: -235, y: 0, z: 195 } // batiment rond
                }
                ,
                {
                    position: { x: 75, y: 0, z: 125 } // bwt
                },
                {
                    position: { x: -22.22, y: 0, z: 176 } // gare
                }
            ],
            attr: [{
                    position: { x: -390, y: 0, z: -141 } //entrepot mutualise
                },

                {
                    position: { x: -106, y: 0, z: -95 } //batiment mutualisé
                },
                {
                    position: { x: 330, y: 0, z: 380 } // port
                },
                {
                    position: { x: 700, y: 0, z: -65 } // gare
                },
                {
                    position: { x: -22.22, y: 0, z: 176 } // gare
                }
            ],
            vie: [{
                    position: { x: -106, y: 0, z: -95 } //batiment mutualisé
                },

                {
                    position: { x: 250, y: 0, z: 220 } // batiment indus 1 a coté port
                },
                {
                    position: { x: -32, y: 0, z: -105 } // batiment indus 1 a coté port
                },
                {
                    position: { x: -235, y: 0, z: 9 } // batiment indus 1 a coté port
                },
            ],
            gouv : [ {
                position: { x: -390, y: 0, z: -141 } //entrepot mutualise
            },
{
                position: { x: -347, y: 0, z: -13 } //prarking a etage
            },
{
                position: { x: -106, y: 0, z: -95 } //batiment mutualisé
            },
{
                position: { x: -22.22, y: 0, z: 176 } // gare
            }]
        }
        this.indicatorRural = {
            sob: [{
                    position: { x: 610, y: 0, z: -60 } //batimnet Logistique
                },
                {
                    position: { x: 0, y: 0, z: -60 } // batiment
                },
                {
                    position: { x: 35, y: 0, z: 195 } // parking covoit
                },
                {
                    position: { x: 100, y: 0, z: 180 } //batiment mutualisé
                },
                {
                    position: { x: -380, y: 0, z: 145 } //batiment mutualisé
                }
            ],
            dur: [{
                    position: { x: -5, y: 0, z: -336 } //batimnet Logistique a droite 
                },
                {
                    position: { x: 119, y: 0, z: -30 } // bwt
                },
                {
                    position: { x: 768, y: 0, z: 191 } // Methaniseur
                },
                {
                    position: { x: 35, y: 0, z: 195 } // parking covoit
                },
                {
                    position: { x: -257.5, y: 0, z: 254 } // batiment classique avec toit vert
                },
                {
                    position: { x: -443, y: 0, z: -66 } // Parking bornes
                },
                {
                    position: { x: 256, y: 0, z: 153 } // Bornes energie
                },
                {
                    position: { x: 210, y: 0, z: 268 }
                },
                {
                    position: { x: -179, y: 0, z: 58 }
                },
               
            ],
            attr: [{
                    position: { x: 316, y: 0, z: 373 } // Port
                },
                {
                    position: { x: 6, y: 0, z: -434 } // Gare
                },
                {
                    position: { x: -380, y: 0, z: 145 } //entrepot mutualisé
                },
                {
                    position: { x: 100, y: 0, z: 180 } //batiment mutualisé
                },
                {
                    position: { x: 256, y: 0, z: 153 } // Bornes energie
                },
            ],
            vie: [{
                    position: { x: 476, y: 0, z: 249 } //batiment mutualisé
                },
               
                {
                    position: { x: 100, y: 0, z: 180 } //batiment mutualisé
                },
                {
                    position: { x: -11, y: 1, z: 58 } //Espace vert
                },
                {
                    position: { x: -78, y:1, z: 222 } //zone de convivialité
                },
                
              
            ],
            gouv: [
                
                {
                    position: { x: 100, y: 0, z: 180 } //batiment mutualisé
                },
                {
                    position: { x: -380, y: 0, z: 145 } //batiment mutualisé
                },
                {
                    position: { x: 35, y: 0, z: 195 } // parking covoit
                },
                {
                    position: { x: 256, y: 0, z: 153 } // Bornes energie
                },


            ]
        }
        this.indicatorPeri = {
            sob: [{
                    position: { x: -210, y: 0, z: 174 } //batimnet Logistique a droite 
                },


                {
                    position: { x: -148, y: 0, z: 76 } //prarking a etage
                },
                {
                    position: { x: -224, y: 0, z: 17 } //batiment mutualisé
                },
                {
                    position: { x: -155, y: 0, z: 17 } //batiment mutualisé
                }
            ],
            dur: [
                {
                    position: { x: 245, y: 0, z: -45 } // bwt
                },
                {
                    position: { x: 115, y: 0, z: -65 } // batiment classique avec toit vert
                },
                {
                    position: { x: 210, y: 0, z: 202 } // Parking bornes
                },
                {
                    position: { x: -190, y: 0, z: -55 } // Parking grand etage
                },
                {
                    position: { x: 35, y: 0, z: 28 } // Bornes energie
                },
                {
                    position: { x: 170, y: 0, z: -65 } // Parking bornes
                },
                {
                    position: { x: 152, y: 0, z: 35 } // Methaniseur
                },
            ],
            attr: [{
                    position: { x: 35, y: 0, z: 28 } // Bornes energie
                },
                {
                    position: { x: -224, y: 0, z: 17 } //batiment mutualisé
                },
                {
                    position: { x: -155, y: 0, z: 17 } //batiment mutualisé
                }

            ],
            vie: [{
                    position: { x: -224, y: 0, z: 17 } //batiment mutualisé
                },
                {
                    position: { x: -27, y: 0, z: 180 } // batiment indus a cote du bat logistique 
                },
               
                {
                    position: { x: 46, y: 0, z: 153 } // batiment indus a cote du bat logistique 
                },
                {
                    position: { x: -72, y: 0, z: -129 } // batiment indus 1 a coté port
                }
            ],
            gouv: [{
                    position: { x: -224, y: 0, z: 17 } //batiment mutualisé
                },
              
                {
                    position: { x: 35, y: 0, z: 28 } // Bornes energie
                },
                {
                    position: { x: -148, y: 0, z: 76 } //prarking a etage
                },
                {
                    position: { x: -160, y: 0, z: 17 } //batiment mutualisé
                },

            ]
        }
        this.currentIntersect = null

        
        if (this.resources.items.urbainModel) {
            this.setUrbainModel()

            this.setVehicule()
            this.animFluxUrbain()

            this.setAnimationVehiculeUrbain()
            this.setNavBarAnimation()
            this.setGroupUrbain()

        }

        if (this.resources.items.periModel) {
            this.setNavBarAnimation()


            this.setPeriModel()

            this.setVehiculePeri()
                        this.animFluxUrbain()

            this.animFLuxPeri()


            this.setAnimationVehicule()
            // this.setFlecheModel()
            this.setGroupPeriUrbain()

        }

        if (this.resources.items.ruralModel) {
            this.setNavBarAnimation()

            this.setRuralModel()

            this.setVehiculeRural()
            this.animFluxRural()
                        this.animFluxUrbain()

            this.setAnimationVehiculeRural()
            this.setGroupRural()
            this.setAnimationEolienne()


        }







        this.scrollClose()
        this.setRaycast()

    }
    clsModelUrb() {
        this.scene.remove(
            this.urbainModel,
            this.vehiculeModel,
            this.ruralModel,
            this.periModel,
            this.gouvernanceUrbain,
            this.batiUrbain,

        )
    }
    clsModelPeri() {
        this.scene.remove(
            this.batiPeri,
            this.vehiculeUrbainModel,
            this.fluxUrbainModel
        )
    }
    clsModelRural() {
        this.scene.remove(
            this.batiRural,
            this.eolienneModel,
            this.vehiculeRuralModel,

        )
    }
    transitionModelOn() {
        const titre = document.querySelector('.titre')
        if (this.experience.current === "0") {
            titre.innerHTML = "Urbaine"
        } else if (this.experience.current === "1") {
            titre.innerHTML = "Périurbaine"
        } else if (this.experience.current === "2") {
            titre.innerHTML = "Rurale"
        }
        gsap.to('.transition', {
            duration: 1,
            opacity: 1,
            display: "flex",
            ease: "power4.out",

        })

    }
    transitionModelOff() {
        gsap.to('.transition', {
            duration: 1,
            opacity: 0,
            display: "none",
            ease: "power4.out",

        })

    }
    validModel() {
        this.navZones = document.getElementsByClassName("navZone")

        // anim de la navbar et nettoyage
        gsap.to(".navbar", {
            translateX: "0%",
            ease: "back.out(1.7)",
            duration: 0.7,
            delay: 3
        })
        this.cls()

        // réinitialisation du menu et des boutons
        this.menuClick = { 0: false, 1: false, 2: false, 3: false, 4: false, 5: false }
        for (let i = 0; i < 5; i++) {
            this.actionButton[i].style.background = "#1A2783"
            this.actionButton[i].style.color = "#fff"
            this.menuClick[i] = false
            gsap.to(this.crossButton[i], { rotate: 0, ease: "back.out(1.7)", color: "#fff" })
        }
        this.setTransition()

        // désactive les interactions le temps des transitions
        this.canvas.style.pointerEvents = "none"

        // récupère la zone courante ("0", "1" ou "2")
        const current = this.experience.current

        if (current === "0") {

            this.transitionModelOn()
            // masque les autres maquettes
            this.clsModelRural()
            this.clsModelPeri()
            this.clsModelUrb()
            // zone urbaine
            // si la maquette urbaine n’est pas encore chargée, on charge la zone



            // instancie les objets urbains

            this.setUrbainModel()
            


            // ajoute les éléments à la scène (ajustez selon vos variables)
            this.scene.add(this.urbainModel, this.batiPeri, this.vehiculeUrbainModel)

            // navigation : retire les classes "active"
            this.navZones[0].classList.remove("active")
            this.navZones[1].classList.remove("active")
            this.navZones[2].classList.remove("active")
            this.navZones[this.experience.current].classList.add("active");

            // anime la caméra et la cible
            gsap.to(this.controls.target, {
                x: -38.8233,
                y: -6.6831,
                z: 19.7368,
                ease: "Power4.easeInOut",
                duration: 3
            })
            gsap.to(this.camera.instance.position, {
                x: -353.6932,
                y: 198.1518,
                z: 375.4336,
                ease: "Power4.easeInOut",
                duration: 3,
                onComplete: () => {
                    this.canvas.style.pointerEvents = "auto"
                    this.transitionModelOff()
                }
            })
            this.setRaycast()



            
        } else if (current === "1") {


            this.transitionModelOn()
            // masque les autres maquettes

            this.clsModelRural()

            this.clsModelPeri()
            this.clsModelUrb()
            // zone péri‑urbaine


            this.setPeriModel()



            this.scene.add(this.periModel, this.batiUrbain, this.vehiculeModel)

            this.navZones[0].classList.remove("active")
            this.navZones[1].classList.remove("active")
            this.navZones[2].classList.remove("active")
            this.navZones[this.experience.current].classList.add("active");

            gsap.to(this.controls.target, {
                x: -38.19536,
                y: -57.923423,
                z: 14.36664,
                ease: "Power4.easeInOut",
                duration: 3
            })
            gsap.to(this.camera.instance.position, {
                x: -373.40963,
                y: 195.45384,
                z: 217.86126,
                ease: "Power4.easeInOut",
                duration: 3,
                onComplete: () => {
                    this.canvas.style.pointerEvents = "auto"
                    this.transitionModelOff()
                }
            })
            this.setRaycast()

        } else if (current === "2") {
            this.transitionModelOn()
            this.clsModelRural()
            this.clsModelPeri()
            this.clsModelUrb()
            // zone rurale


            this.setRuralModel()
            this.scene.add(this.ruralModel, this.batiRural, this.vehiculeRuralModel, this.eolienneModel)

            this.navZones[0].classList.remove("active")
            this.navZones[1].classList.remove("active")
            this.navZones[2].classList.remove("active")
            this.navZones[this.experience.current].classList.add("active");

            gsap.to(this.controls.target, {
                x: -200.1672,
                y: 7.6308,
                z: -236.9340,
                ease: "Power4.easeInOut",
                duration: 3
            })
            gsap.to(this.camera.instance.position, {
                x: -687.4602,
                y: 210.49697,
                z: 492.03155,
                ease: "Power4.easeInOut",
                duration: 3,
                onComplete: () => {
                    this.canvas.style.pointerEvents = "auto"
                    this.transitionModelOff()
                }
            })
            this.setRaycast()
        }
    }
    switchModel() {
        this.zoneButton = document.getElementsByClassName("zones")
        this.startExperience = document.querySelector(".startExperience")
        this.navZones = document.getElementsByClassName("navZone")

        this.startExperience.addEventListener("click", () => {
            gsap.to(".homePage", {
                opacity: 0,
                display: "none",
                delay: 0.4
            })
            this.startExperience.innerHTML = "LOADING ..."
            this.startExperience.classList.add("loading")

            this.resources.loadZone();

            this.validModel()
            this.navZones[`${this.experience.current}`].classList.add("active")
        })

        for (let i = 0; i < this.zoneButton.length; i++) {
            this.zoneButton[i].addEventListener("click", () => {
                this.experience.current = document.querySelector(
                    `#zones${i}`
                ).dataset.select
                this.zoneButton[0].classList.remove("select")
                this.zoneButton[1].classList.remove("select")
                this.zoneButton[2].classList.remove("select")
                this.zoneButton[i].classList.add("select")
                gsap.to(this.zoneButton[i], {
                    scale: 1.05,
                    duration: 0.1,
                    onComplete: () => {
                        gsap.to(this.zoneButton[i], {
                            scale: 1,
                            duration: 0.1
                        })
                    }
                })
            })
        }
        for (let i = 0; i < this.navZones.length; i++) {
            this.navZones[i].addEventListener("click", () => {
                this.experience.current = `${i}`
                this.validModel()
                this.navZones[i].classList.add("active")
            })
        }
    }
    setNavBarAnimation() {
        this.crossButton = document.getElementsByClassName("cross")
        this.actionButton = document.getElementsByClassName("action_button")

        for (let i = 0; i < 6; i++) {
            this.actionButton[i].addEventListener("click", () => {
                if (!this.menuClick[i]) {
                    for (let i = 0; i < 6; i++) {
                        this.menuClick[i] = false
                        // this.actionButton[i].style.background = "#1A2783"
                        // this.actionButton[i].style.color = "#fff"
                        gsap.to(this.actionButton[i].style, {
                            color: "#fff",
                            background: "#1A2783"

                        })
                        gsap.to(this.crossButton[i], {
                            rotate: 0,
                            ease: "back.out(1.7)",
                            color: "#fff"

                        })
                    }

                    this.menuClick[i] = true
                    gsap.to(this.crossButton[i], {
                        rotate: 45,
                        ease: "back.out(1.7)",
                        color: "#1A2783"
                    })

                    gsap.to(this.actionButton[i].style, {
                        color: "#1A2783",
                        background: "#fff"

                    })


                } else {
                    gsap.to(this.actionButton[i].style, {
                        color: "#fff",
                        background: "#1A2783"
                    })
                    this.menuClick[i] = false
                    gsap.to(this.crossButton[i], {
                        rotate: 0,
                        ease: "back.out(1.7)",
                        color: "#fff"

                    })
                }
            })
        }
    }

    indicUrbain() {
        if (this.indicFollower == 1) {
            for (let i = 0; i < this.indicatorUrbain.sob.length; i++) {
                this.clonedMesh = this.indicator.scene.children[0].clone()
                this.clonedMesh.scale.z = 0
                this.clonedMesh.position.set(
                    this.indicatorUrbain.sob[i].position.x,
                    this.indicatorUrbain.sob[i].position.y,
                    this.indicatorUrbain.sob[i].position.z
                )
                this.scene.add(this.clonedMesh)
                gsap.to(this.clonedMesh.scale, {
                    z: 0.04,
                    delay: 3
                })
            }
        } else if (this.indicFollower == 2) {
            for (let i = 0; i < this.indicatorUrbain.dur.length; i++) {
                this.clonedMesh = this.indicator.scene.children[0].clone()
                this.clonedMesh.scale.z = 0

                this.clonedMesh.position.set(
                    this.indicatorUrbain.dur[i].position.x,
                    this.indicatorUrbain.dur[i].position.y,
                    this.indicatorUrbain.dur[i].position.z
                )
                this.scene.add(this.clonedMesh)
                gsap.to(this.clonedMesh.scale, {
                    z: 0.04,
                    delay: 3
                })
            }
        } else if (this.indicFollower == 3) {
            for (let i = 0; i < this.indicatorUrbain.attr.length; i++) {
                this.clonedMesh = this.indicator.scene.children[0].clone()
                this.clonedMesh.scale.z = 0

                this.clonedMesh.position.set(
                    this.indicatorUrbain.attr[i].position.x,
                    this.indicatorUrbain.attr[i].position.y,
                    this.indicatorUrbain.attr[i].position.z
                )
                this.scene.add(this.clonedMesh)
                gsap.to(this.clonedMesh.scale, {
                    z: 0.04,
                    delay: 3
                })
            }
        } else if (this.indicFollower == 4) {
            for (let i = 0; i < this.indicatorUrbain.vie.length; i++) {
                this.clonedMesh = this.indicator.scene.children[0].clone()
                this.clonedMesh.scale.z = 0

                this.clonedMesh.position.set(
                    this.indicatorUrbain.vie[i].position.x,
                    this.indicatorUrbain.vie[i].position.y,
                    this.indicatorUrbain.vie[i].position.z
                )

                this.scene.add(this.clonedMesh)
                gsap.to(this.clonedMesh.scale, {
                    z: 0.04,
                    delay: 3
                })
            }
        }
        else if (this.indicFollower == 5) {
            for (let i = 0; i < this.indicatorUrbain.gouv.length; i++) {
                this.clonedMesh = this.indicator.scene.children[0].clone()
                this.clonedMesh.scale.z = 0

                this.clonedMesh.position.set(
                    this.indicatorUrbain.gouv[i].position.x,
                    this.indicatorUrbain.gouv[i].position.y,
                    this.indicatorUrbain.gouv[i].position.z
                )

                this.scene.add(this.clonedMesh)
                gsap.to(this.clonedMesh.scale, {
                    z: 0.04,
                    delay: 3
                })
            }
        }
    }
    indicPeri() {
        if (this.indicFollower == 1) {
            for (let i = 0; i < this.indicatorPeri.sob.length; i++) {
                this.clonedMesh = this.indicator.scene.children[0].clone()
                this.clonedMesh.scale.z = 0
                this.clonedMesh.position.set(
                    this.indicatorPeri.sob[i].position.x,
                    this.indicatorPeri.sob[i].position.y,
                    this.indicatorPeri.sob[i].position.z
                )
                this.scene.add(this.clonedMesh)
                gsap.to(this.clonedMesh.scale, {
                    z: 0.04,
                    delay: 3
                })
            }
        } else if (this.indicFollower == 2) {
            for (let i = 0; i < this.indicatorPeri.dur.length; i++) {
                this.clonedMesh = this.indicator.scene.children[0].clone()
                this.clonedMesh.scale.z = 0

                this.clonedMesh.position.set(
                    this.indicatorPeri.dur[i].position.x,
                    this.indicatorPeri.dur[i].position.y,
                    this.indicatorPeri.dur[i].position.z
                )
                this.scene.add(this.clonedMesh)
                gsap.to(this.clonedMesh.scale, {
                    z: 0.04,
                    delay: 3
                })
            }
        } else if (this.indicFollower == 3) {
            for (let i = 0; i < this.indicatorPeri.attr.length; i++) {
                this.clonedMesh = this.indicator.scene.children[0].clone()
                this.clonedMesh.scale.z = 0

                this.clonedMesh.position.set(
                    this.indicatorPeri.attr[i].position.x,
                    this.indicatorPeri.attr[i].position.y,
                    this.indicatorPeri.attr[i].position.z
                )
                this.scene.add(this.clonedMesh)
                gsap.to(this.clonedMesh.scale, {
                    z: 0.04,
                    delay: 3
                })
            }
        } else if (this.indicFollower == 4) {
            for (let i = 0; i < this.indicatorPeri.vie.length; i++) {
                this.clonedMesh = this.indicator.scene.children[0].clone()
                this.clonedMesh.scale.z = 0

                this.clonedMesh.position.set(
                    this.indicatorPeri.vie[i].position.x,
                    this.indicatorPeri.vie[i].position.y,
                    this.indicatorPeri.vie[i].position.z
                )

                this.scene.add(this.clonedMesh)
                gsap.to(this.clonedMesh.scale, {
                    z: 0.04,
                    delay: 3
                })
            }
        } else if (this.indicFollower == 5) {
            for (let i = 0; i < this.indicatorPeri.gouv.length; i++) {
                this.clonedMesh = this.indicator.scene.children[0].clone()
                this.clonedMesh.scale.z = 0

                this.clonedMesh.position.set(
                    this.indicatorPeri.gouv[i].position.x,
                    this.indicatorPeri.gouv[i].position.y,
                    this.indicatorPeri.gouv[i].position.z
                )

                this.scene.add(this.clonedMesh)
                gsap.to(this.clonedMesh.scale, {
                    z: 0.04,
                    delay: 3
                })
            }
        }
    }
    indicRural() {
        if (this.indicFollower == 1) {
            for (let i = 0; i < this.indicatorRural.sob.length; i++) {
                this.clonedMesh = this.indicator.scene.children[0].clone()
                this.clonedMesh.scale.z = 0
                this.clonedMesh.position.set(
                    this.indicatorRural.sob[i].position.x,
                    this.indicatorRural.sob[i].position.y,
                    this.indicatorRural.sob[i].position.z
                )
                this.scene.add(this.clonedMesh)
                gsap.to(this.clonedMesh.scale, {
                    z: 0.04,
                    delay: 3
                })
            }
        } else if (this.indicFollower == 2) {
            for (let i = 0; i < this.indicatorRural.dur.length; i++) {
                this.clonedMesh = this.indicator.scene.children[0].clone()
                this.clonedMesh.scale.z = 0

                this.clonedMesh.position.set(
                    this.indicatorRural.dur[i].position.x,
                    this.indicatorRural.dur[i].position.y,
                    this.indicatorRural.dur[i].position.z
                )
                this.scene.add(this.clonedMesh)
                gsap.to(this.clonedMesh.scale, {
                    z: 0.04,
                    delay: 3
                })
            }
        } else if (this.indicFollower == 3) {
            for (let i = 0; i < this.indicatorRural.attr.length; i++) {
                this.clonedMesh = this.indicator.scene.children[0].clone()
                this.clonedMesh.scale.z = 0

                this.clonedMesh.position.set(
                    this.indicatorRural.attr[i].position.x,
                    this.indicatorRural.attr[i].position.y,
                    this.indicatorRural.attr[i].position.z
                )
                this.scene.add(this.clonedMesh)
                gsap.to(this.clonedMesh.scale, {
                    z: 0.04,
                    delay: 3
                })
            }
        } else if (this.indicFollower == 4) {
            for (let i = 0; i < this.indicatorRural.vie.length; i++) {
                this.clonedMesh = this.indicator.scene.children[0].clone()
                this.clonedMesh.scale.z = 0

                this.clonedMesh.position.set(
                    this.indicatorRural.vie[i].position.x,
                    this.indicatorRural.vie[i].position.y,
                    this.indicatorRural.vie[i].position.z
                )

                this.scene.add(this.clonedMesh)
                gsap.to(this.clonedMesh.scale, {
                    z: 0.04,
                    delay: 3
                })
            }
        } else if (this.indicFollower == 5) {
            for (let i = 0; i < this.indicatorRural.gouv.length; i++) {
                this.clonedMesh = this.indicator.scene.children[0].clone()
                this.clonedMesh.scale.z = 0

                this.clonedMesh.position.set(
                    this.indicatorRural.gouv[i].position.x,
                    this.indicatorRural.gouv[i].position.y,
                    this.indicatorRural.gouv[i].position.z
                )

                this.scene.add(this.clonedMesh)
                gsap.to(this.clonedMesh.scale, {
                    z: 0.04,
                    delay: 3
                })
            }
        }
    }
    setGroupPeriUrbain() {
        this.gouvernanceUrbain = new THREE.Group()
        this.batiUrbain = new THREE.Group()
        this.eauUrbain = new THREE.Group()
        this.elecUrbain = new THREE.Group()
        this.gazUrbain = new THREE.Group()
        this.hydroUrbain = new THREE.Group()
        this.chaleurUrbain = new THREE.Group()
        this.dataPeri = new THREE.Group()

        this.dataPeri.add(
            this.resources.items.fluxUrbain.scene.getObjectByName("5G"),

        )
        this.elecUrbain.add(
            this.resources.items.flecheModel.scene.getObjectByName("Elec_Fleche_alambic_auto_conso1"),
            this.resources.items.flecheModel.scene.getObjectByName("Elec_Fleche_alambic_1"),
            this.resources.items.flecheModel.scene.getObjectByName("Elec_Fleche_alambic_2"),
            this.resources.items.flecheModel.scene.getObjectByName("Elec_Fleche_alambic_02_borne1"),
            this.resources.items.flecheModel.scene.getObjectByName("Elec_Fleche_alambic_03_borne1"),
            this.resources.items.flecheModel.scene.getObjectByName("Elec-Fleche-01"),
            this.resources.items.flecheModel.scene.getObjectByName("Elec-Fleche-003"),
            this.resources.items.flecheModel.scene.getObjectByName("Elec-Fleche-002"),
            this.resources.items.flecheModel.scene.getObjectByName("Elec-Fleche-004"),
            this.resources.items.flecheModel.scene.getObjectByName("Elec-picto-borne"),
            this.resources.items.flecheModel.scene.getObjectByName("Texte-elec-conso-02"),
            this.resources.items.flecheModel.scene.getObjectByName("Elec-Text-conso-01"),
            this.resources.items.flecheModel.scene.getObjectByName("Elec-picto-recyclage"),
            this.resources.items.flecheModel.scene.getObjectByName("Elec-Text-produc"),
            this.resources.items.flecheModel.scene.getObjectByName("Elec-Text-conso-01-auto-conso"),
            this.resources.items.flecheModel.scene.getObjectByName("Elec-Text-conso-03-auto-conso"),
            this.resources.items.flecheModel.scene.getObjectByName("Texte-elec-produc-02"),
            this.resources.items.flecheModel.scene.getObjectByName("Elec-Text-conso-03-auto-conso001")
        )

        this.prodUrbain = this.elecUrbain.getObjectByName("Texte-elec-produc-02").clone()
        this.prodUrbain.position.x = 459
        this.prodUrbain.position.y = 17
        this.prodUrbain.position.z = 272
        this.prodUrbain.material = this.materialYellow


        // if (this.debug.active) {
        //     this.debugFolder = this.debug.ui.addFolder("POSITION")
        //     this.debugFolder
        //         .add(  this.prodUrbain.position, "x", -1000, 1000, 1)
        //         .name("Position X")
        //     this.debugFolder
        //         .add(  this.prodUrbain.position, "y", -1000, 1000, 1)
        //         .name("Position Y")
        //     this.debugFolder
        //         .add(  this.prodUrbain.position, "z", -1000, 1000, 1)
        //         .name("Position Z")


        // }
        // console.log(this.resources.items.flecheModel.scene);

        this.eauUrbain.add(
            this.resources.items.flecheModel.scene.getObjectByName("eau_base1"),
            this.resources.items.flecheModel.scene.getObjectByName("eau_base2"),
            this.resources.items.flecheModel.scene.getObjectByName("eau_base3"),
            this.resources.items.flecheModel.scene.getObjectByName("eau_base4"),
            this.resources.items.flecheModel.scene.getObjectByName("eau_base5"),
            this.resources.items.flecheModel.scene.getObjectByName("eau_base6"),
            this.resources.items.flecheModel.scene.getObjectByName("eau_base7"),
            this.resources.items.flecheModel.scene.getObjectByName("eau_base8"),
            this.resources.items.flecheModel.scene.getObjectByName("eau_base9"),
            this.resources.items.flecheModel.scene.getObjectByName("eau_base10"),
            this.resources.items.flecheModel.scene.getObjectByName("traitement_des_eaux"),
            this.resources.items.flecheModel.scene.getObjectByName("zone-Eau-BWT"),

            // this.recupEau


        )

        // this.recupEau.position.x = -131
        // this.recupEau.position.y = 15
        // this.recupEau.position.z = -205
        // this.recupEau.material = this.materialYellow
        // console.log(this.resources.items.flecheModel.scene);
        this.eauUrbain.getObjectByName("zone-Eau-BWT").material = this.materialBlueOpacity
        this.eauUrbain.getObjectByName("eau_base1").material = this.materialYellow
        this.eauUrbain.getObjectByName("eau_base2").material = this.materialYellow
        this.eauUrbain.getObjectByName("traitement_des_eaux").material = this.materialBlue


        this.eauUrbain.getObjectByName("eau_base3").material = this.materialYellow
        this.eauUrbain.getObjectByName("eau_base4").material = this.materialYellow
        this.eauUrbain.getObjectByName("eau_base5").material = this.materialYellow
        this.eauUrbain.getObjectByName("eau_base6").material = this.materialYellow
        this.eauUrbain.getObjectByName("eau_base7").material = this.materialYellow
        this.eauUrbain.getObjectByName("eau_base8").material = this.materialYellow
        this.eauUrbain.getObjectByName("eau_base9").material = this.materialYellow
        this.eauUrbain.getObjectByName("eau_base10").material = this.materialBlue


        this.hydroUrbain.add(
            this.resources.items.flecheModel.scene.getObjectByName("H2-OK"),
            this.resources.items.flecheModel.scene.getObjectByName("H2-text-01"),
            this.resources.items.flecheModel.scene.getObjectByName("H2-text-01001"),
            this.prodUrbain

        )
        this.hydroUrbain.getObjectByName("H2-OK").material = this.materialBlue
        this.hydroUrbain.getObjectByName("H2-text-01001").material = this.materialBlue
        this.hydroUrbain.getObjectByName("H2-text-01").material = this.materialBlue


        this.chaleurUrbain.add(
            this.resources.items.flecheModel.scene.getObjectByName("Chaleur-urbain"),
            this.resources.items.flecheModel.scene.getObjectByName("Chaleur-Geo")
        )

        this.chaleurUrbain.getObjectByName("Chaleur-urbain").material = this.materialBlue
        this.chaleurUrbain.getObjectByName("Chaleur-Geo").material = this.materialBlue
        this.gazUrbain.add(
            this.resources.items.flecheModel.scene.getObjectByName("GAZ-OK"),
            this.resources.items.flecheModel.scene.getObjectByName("Gaz-text-02"),
            this.resources.items.flecheModel.scene.getObjectByName("Gaz-text-03"),
            this.resources.items.flecheModel.scene.getObjectByName("Gaz-text-01")
        )

        this.gazUrbain.getObjectByName("GAZ-OK").material = this.materialBlue
        this.gazUrbain.getObjectByName("Gaz-text-02").material = this.materialBlue
        this.gazUrbain.getObjectByName("Gaz-text-03").material = this.materialBlue
        this.gazUrbain.getObjectByName("Gaz-text-01").material = this.materialBlue




        this.elecUrbain.getObjectByName("Elec-Fleche-01").material = this.materialYellow
        this.elecUrbain.getObjectByName("Elec-Fleche-003").material = this.materialYellow
        this.elecUrbain.getObjectByName("Elec-Fleche-002").material = this.materialYellow
        this.elecUrbain.getObjectByName("Elec-Fleche-004").material = this.materialYellow
        this.elecUrbain.getObjectByName("Elec-Text-produc").material = this.materialYellow
        this.elecUrbain.getObjectByName("Elec-picto-borne").material = this.materialGrey
        this.elecUrbain.getObjectByName("Elec-Text-conso-01-auto-conso").material = this.materialYellow
        this.elecUrbain.getObjectByName("Elec_Fleche_alambic_1").material = this.materialBlue
        this.elecUrbain.getObjectByName("Elec_Fleche_alambic_2").material = this.materialYellow
        this.elecUrbain.getObjectByName("Elec-Text-conso-03-auto-conso001").material = this.materialBlue
        this.elecUrbain.getObjectByName("Elec_Fleche_alambic_auto_conso1").material = this.materialYellow
        this.elecUrbain.getObjectByName("Texte-elec-produc-02").material = this.materialYellow
        this.elecUrbain.getObjectByName("Elec-Text-conso-01").material = this.materialBlue
        this.elecUrbain.getObjectByName("Elec-picto-recyclage").material = this.materialGrey
        this.elecUrbain.getObjectByName("Elec-Text-conso-03-auto-conso").material = this.materialBlue
        this.elecUrbain.getObjectByName("Texte-elec-conso-02").material = this.materialBlue
        this.elecUrbain.getObjectByName("Elec_Fleche_alambic_02_borne1").material = this.materialYellow
        this.elecUrbain.getObjectByName("Elec_Fleche_alambic_03_borne1").material = this.materialYellow







        this.batiUrbain.add(
            this.resources.items.periModel.scene.getObjectByName("Bat_Batiment_Indus1"),
            this.resources.items.periModel.scene.getObjectByName("parking-etage"),
            this.resources.items.periModel.scene.getObjectByName("Bat_Batiment_Mutualise"),
            this.resources.items.periModel.scene.getObjectByName("Bat_Batiment_Logistique"),
            this.resources.items.periModel.scene.getObjectByName("Bat_Batiment_Intermediaire"),
            this.resources.items.periModel.scene.getObjectByName("Bat_Borne_Recharge"),
            this.resources.items.periModel.scene.getObjectByName("Bat_Entrepot_Mutualise"),
            this.resources.items.periModel.scene.getObjectByName("Bat_Gare"),
            this.resources.items.periModel.scene.getObjectByName("Bat_Port_Partie2"),
            this.resources.items.periModel.scene.getObjectByName("port-for-bake"),
            this.resources.items.periModel.scene.getObjectByName("Bat_Batiment_Indus2"),
            this.resources.items.periModel.scene.getObjectByName("Boite_caisson"),
            this.resources.items.periModel.scene.getObjectByName("Bat_Batiment_Indus3"),
            // this.periModel.getObjectByName("Eclairage-intel"),
            this.resources.items.periModel.scene.getObjectByName("ombrieres-PV001"),
            this.resources.items.periModel.scene.getObjectByName("ombrieres-PV002"),
            this.resources.items.periModel.scene.getObjectByName("ombrieres-PV003"),
            this.resources.items.flecheModel.scene.getObjectByName("espace-convivial"),
            this.resources.items.flecheModel.scene.getObjectByName("espace-vert-pieton"),





          this.resources.items.periModel.scene.getObjectByName("terrain-ENV-04"),

        )
        const materiel = new THREE.MeshBasicMaterial({ transparent: true, opacity: 0 })
        this.batiUrbain.getObjectByName("espace-convivial").material = materiel
        this.batiUrbain.getObjectByName("espace-vert-pieton").material = materiel
        // console.log(this.periModel);
        // console.log(this.batiUrbain);
        this.gouvernanceUrbain.add(
            this.resources.items.flecheModel.scene.getObjectByName("Gouvernance-02-01"),
            this.resources.items.flecheModel.scene.getObjectByName("Gouvernance-02-02"),
            this.resources.items.flecheModel.scene.getObjectByName("Gouvernance-01-01"),
            this.resources.items.flecheModel.scene.getObjectByName("Gouvernance-01-02"),
            this.resources.items.flecheModel.scene.getObjectByName("Gouvernance-01-03"),
            this.resources.items.flecheModel.scene.getObjectByName("Gouvernance-01-04"),
            this.resources.items.flecheModel.scene.getObjectByName("Gouvernance-Text-01-01"),
            this.resources.items.flecheModel.scene.getObjectByName("Gouvernance-Text-01-02"),
            this.resources.items.flecheModel.scene.getObjectByName("Gouvernance-Text-02"),
            this.resources.items.flecheModel.scene.getObjectByName("Gouvernance-Text-03")
        )

        // this.scene.add(this.batiUrbain)
    }
    setGroupUrbain() {
        this.gouvernancePeri = new THREE.Group()
        this.batiPeri = new THREE.Group()
        this.eauPeri = new THREE.Group()
        this.elecPeri = new THREE.Group()
        this.gazPeri = new THREE.Group()
        this.hydroPeri = new THREE.Group()
        this.chaleurPeri = new THREE.Group()
        this.spacesPeri = new THREE.Group()
        this.dataPeri = new THREE.Group()


        this.elecPeri.add(
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec_Fleche_alambic_auto_conso1"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec_Fleche_alambic_2001"),

            this.resources.items.fluxUrbain.scene.getObjectByName("Elec-Text-conso-01-auto-conso"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec-picto-recyclage"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec-picto-borne"),

            this.resources.items.fluxUrbain.scene.getObjectByName("Elec-Fleche-01"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec-Fleche-005"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec-Fleche-004"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec-Text-conso-01001"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec-Text-conso-03"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec_Fleche_alambic_2"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec_Fleche_alambic_1"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec-Text-conso-01"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec-Text-produc-02"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec-Text-conso-02"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec-Text-produc"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec-Text-conso-03-auto-conso"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec-Text-conso-03-auto-conso001"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec_Fleche_alambic_03_borne1"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Elec_Fleche_alambic_02_borne1"),
        )
        this.productionCLoneMesh = this.elecPeri.getObjectByName("Elec-Text-conso-01-auto-conso").clone()
        this.productionCLoneMesh.position.x = 140
        this.productionCLoneMesh.position.y = 21
        this.productionCLoneMesh.position.z = 37

        this.dataPeri.add(
            this.resources.items.fluxUrbain.scene.getObjectByName("5G"),

        )
        this.spacesPeri.add(
            this.resources.items.fluxUrbain.scene.getObjectByName("park"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Velo"),
            this.resources.items.fluxUrbain.scene.getObjectByName("MOB-douce"),

        )
        this.spacesPeri.position.y = 0.1
        this.eauPeri.add(
            this.resources.items.fluxUrbain.scene.getObjectByName("eau_base_2"),
            this.resources.items.fluxUrbain.scene.getObjectByName("eau_text_recup"),
            this.resources.items.fluxUrbain.scene.getObjectByName("eau_base_03_1"),
            this.resources.items.fluxUrbain.scene.getObjectByName("eau_base_04_1"),
            this.resources.items.fluxUrbain.scene.getObjectByName("eau_base_05_1"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Traitement_des_eaux"),
            this.resources.items.fluxUrbain.scene.getObjectByName("eau_base_1"),
            this.resources.items.fluxUrbain.scene.getObjectByName("eau_base_03_2"),
            this.resources.items.fluxUrbain.scene.getObjectByName("eau_base_04_2"),
            this.resources.items.fluxUrbain.scene.getObjectByName("eau_base_05_2"),
            this.resources.items.fluxUrbain.scene.getObjectByName("flux_eau_retraitee"),
            this.resources.items.fluxUrbain.scene.getObjectByName("BWT"),

        )

        this.eauPeri.getObjectByName("BWT").material = this.materialBlueOpacity
        this.eauPeri.getObjectByName("Traitement_des_eaux").material = this.materialBlue
        this.eauPeri.getObjectByName("eau_base_05_1").material = this.materialBlue
        this.eauPeri.getObjectByName("eau_base_05_2").material = this.materialBlue
        this.eauPeri.getObjectByName("flux_eau_retraitee").material = this.materialBlue

        this.eauPeri.getObjectByName("eau_base_2").material = this.materialYellow
        this.eauPeri.getObjectByName("eau_text_recup").material = this.materialYellow
        this.eauPeri.getObjectByName("eau_base_03_1").material = this.materialYellow
        this.eauPeri.getObjectByName("eau_base_04_1").material = this.materialYellow
        this.eauPeri.getObjectByName("eau_base_1").material = this.materialYellow
        this.eauPeri.getObjectByName("eau_base_03_2").material = this.materialYellow
        this.eauPeri.getObjectByName("eau_base_04_2").material = this.materialYellow

        // const material = new THREE.MeshBasicMaterial({color: 0xff0000, opacity: 0.7, transparent: true});
        // this.eauPeri.getObjectByName("MOB-douce").material = material;

        this.eauPeri.position.y = 0.1

        this.hydroPeri.add(
            this.resources.items.fluxUrbain.scene.getObjectByName("H2-OK"), //fleche
            this.resources.items.fluxUrbain.scene.getObjectByName("multi-energie"),
            this.resources.items.fluxUrbain.scene.getObjectByName("H2-text-01"), // texte en haut 
            this.productionCLoneMesh


        )
        this.hydroPeri.getObjectByName("multi-energie").material = this.materialBlueOpacity
        this.hydroPeri.getObjectByName("H2-OK").material = this.materialBlue
        this.hydroPeri.getObjectByName("H2-text-01").material = this.materialBlue



        this.chaleurPeri.add(
            this.resources.items.fluxUrbain.scene.getObjectByName("Chaleur-OK"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Chaleur-urbain"),
        )
        this.chaleurPeri.getObjectByName("Chaleur-urbain").material = this.materialBlue
        this.chaleurPeri.getObjectByName("Chaleur-OK").material = this.materialBlue



        this.gazPeri.add(
            this.resources.items.fluxUrbain.scene.getObjectByName("GAZ-OK"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Gaz-text-03"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Gaz-text-02"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Gaz-text-01"),

        )

        this.gazPeri.getObjectByName("GAZ-OK").material = this.materialBlue
        this.gazPeri.getObjectByName("Gaz-text-03").material = this.materialBlue
        this.gazPeri.getObjectByName("Gaz-text-02").material = this.materialBlue
        this.gazPeri.getObjectByName("Gaz-text-01").material = this.materialBlue


        this.elecPeri.getObjectByName("Elec_Fleche_alambic_auto_conso1").material = this.materialYellow
        this.elecPeri.getObjectByName("Elec_Fleche_alambic_2001").material = this.materialYellow
        this.elecPeri.getObjectByName("Elec_Fleche_alambic_03_borne1").material = this.materialYellow
        this.elecPeri.getObjectByName("Elec-Fleche-004").material = this.materialYellow
        this.elecPeri.getObjectByName("Elec_Fleche_alambic_02_borne1").material = this.materialYellow
        this.elecPeri.getObjectByName("Elec-Text-conso-01-auto-conso").material = this.materialYellow
        this.elecPeri.getObjectByName("Elec-picto-recyclage").material = this.materialGrey
        this.elecPeri.getObjectByName("Elec-picto-borne").material = this.materialGrey
        this.elecPeri.getObjectByName("Elec-Fleche-01").material = this.materialYellow

        this.elecPeri.getObjectByName("Elec-Fleche-005").material = this.materialYellow

        this.elecPeri.getObjectByName("Elec-Text-produc").material = this.materialYellow
        this.elecPeri.getObjectByName("Elec_Fleche_alambic_1").material = this.materialBlue
        this.elecPeri.getObjectByName("Elec_Fleche_alambic_2").material = this.materialYellow
        this.elecPeri.getObjectByName("Elec-Text-produc-02").material = this.materialYellow
        this.elecPeri.getObjectByName("Elec-Text-conso-01").material = this.materialBlue
        this.elecPeri.getObjectByName("Elec-Text-conso-01001").material = this.materialBlue
        this.elecPeri.getObjectByName("Elec-Text-conso-02").material = this.materialBlue
        this.elecPeri.getObjectByName("Elec-Text-conso-03").material = this.materialBlue
        this.elecPeri.getObjectByName("Elec-Text-conso-03-auto-conso001").material = this.materialBlue
        this.elecPeri.getObjectByName("Elec-Text-conso-03-auto-conso").material = this.materialBlue










        // console.log(this.urbainModel);
        this.batiPeri.add(
            this.urbainModel.getObjectByName("ombrieres_Parking4"),
            this.urbainModel.getObjectByName("Parking2"),
            this.urbainModel.getObjectByName("Parking1"),
            this.urbainModel.getObjectByName("Parking3"),
            this.urbainModel.getObjectByName("Entrepot_Mutualise"),
            this.urbainModel.getObjectByName("Batiment_Industriel"),
            this.urbainModel.getObjectByName("Batiment_Classique"),
            this.urbainModel.getObjectByName("Batiment_Logistique"),
            this.urbainModel.getObjectByName("Batiment_Mutualise"),
            this.urbainModel.getObjectByName("Borne_Hydrogene"),
            this.resources.items.fluxUrbain.scene.getObjectByName("espace-convivial001"),
            this.resources.items.fluxUrbain.scene.getObjectByName("espace-vert-pieton001"),
            this.urbainModel.getObjectByName("ombrieres_Parking3"),
            this.urbainModel.getObjectByName("Boite_Caisson"),

            this.urbainModel.getObjectByName("Methaniseur"),

            this.urbainModel.getObjectByName("Bati")
        )
        const material = new THREE.MeshBasicMaterial({ color: 0xff0000, opacity: 0, transparent: true });
        this.batiPeri.getObjectByName("espace-vert-pieton001").position.y = 0.1
        this.batiPeri.getObjectByName("espace-convivial001").position.y = 0.1
        this.batiPeri.getObjectByName("espace-vert-pieton001").material = material
        this.batiPeri.getObjectByName("espace-convivial001").material = material


        this.gouvernancePeri.add(
            this.resources.items.fluxUrbain.scene.getObjectByName("Gouvernance-Text-02"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Gouvernance-Text-01-01"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Gouvernance-01-01"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Gouvernance-01-02"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Gouvernance-02-02"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Gouvernance-01-03"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Gouvernance-01-04"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Gouvernance-Text-03"),
            this.resources.items.fluxUrbain.scene.getObjectByName("Gouvernance-Text-01-02"),
            this.resources.items.fluxUrbain.scene.getObjectByName(
                "Gouvernance-02-01"),
        )
        // console.log(this.resources.items.fluxUrbain.scene);
        // this.scene.add(this.batiPeri)
    }

    setGroupRural() {

        this.gouvernanceRural = new THREE.Group()
        this.batiRural = new THREE.Group()
        this.eauRural = new THREE.Group()

        this.elecRural = new THREE.Group()
        this.gazRural = new THREE.Group()
        this.spaceRural = new THREE.Group()

        this.hydroRural = new THREE.Group()

        this.elecRural.add(
            this.fluxRuralModel.getObjectByName("Elec-Text-produc-02"),
            this.fluxRuralModel.getObjectByName("Elec_Fleche_alambic_03_borne1"),
            this.fluxRuralModel.getObjectByName("Elec_Fleche_alambic_05"),
            this.fluxRuralModel.getObjectByName("Elec-Fleche-001"),
            this.fluxRuralModel.getObjectByName("Elec-Fleche-002"),
            this.fluxRuralModel.getObjectByName("Elec-Fleche-004"),
            this.fluxRuralModel.getObjectByName("Elec_Fleche_alambic_02_borne1"),
            this.fluxRuralModel.getObjectByName("Elec_Fleche_alambic_04"),
            this.fluxRuralModel.getObjectByName("Elec_Fleche_alambic_auto_conso1"),
            this.fluxRuralModel.getObjectByName("Elec-Fleche-003"),
            this.fluxRuralModel.getObjectByName("Elec-Text-conso-01001"),
            this.fluxRuralModel.getObjectByName("Elec-Text-conso-01"),
            this.fluxRuralModel.getObjectByName("Elec-picto-recyclage"),
            this.fluxRuralModel.getObjectByName("Elec-picto-borne"),
            this.fluxRuralModel.getObjectByName("Elec-Text-produc-01"),
            this.fluxRuralModel.getObjectByName("Elec-Text-conso-02-auto-conso"),
            this.fluxRuralModel.getObjectByName("Elec-Text-conso-03-auto-conso"),
            this.fluxRuralModel.getObjectByName("Elec-Text-conso-01-auto-conso"),
            this.fluxRuralModel.getObjectByName("Elec-Text-conso-02"),
            this.fluxRuralModel.getObjectByName("park"),
        )
        this.cloneProdMesh = this.elecRural.getObjectByName("Elec-Text-produc-02").clone()
        this.methanProd = this.elecRural.getObjectByName("Elec-Text-produc-02").clone()

        this.cloneProdMesh.position.x = 185
        this.cloneProdMesh.position.y = 15
        this.cloneProdMesh.position.z = 266



        this.eauRural.add(
            this.fluxRuralModel.getObjectByName("eau_base_03_05"),
            this.fluxRuralModel.getObjectByName("eau_base_03_06"),
            this.fluxRuralModel.getObjectByName("eau_base_03_04"),
            this.fluxRuralModel.getObjectByName("eau_base_04_03"),
            this.fluxRuralModel.getObjectByName("eau_base_04_04"),
            this.fluxRuralModel.getObjectByName("eau_base_05_03"),
            this.fluxRuralModel.getObjectByName("eau_base_05_04"),
            this.fluxRuralModel.getObjectByName("eau_base_06"),
            this.fluxRuralModel.getObjectByName("eau_base_07"),
            this.fluxRuralModel.getObjectByName("zone_Eau_BWT"),
            this.fluxRuralModel.getObjectByName("eau_text_recup"),
            this.fluxRuralModel.getObjectByName("Traitement_des_eaux"),
        )
        this.recupEau = this.eauRural.getObjectByName("eau_text_recup").clone()

        // console.log(this.fluxRuralModel);
        this.eauRural.getObjectByName("eau_base_05_04").material = this.materialBlue
        this.eauRural.getObjectByName("eau_base_05_03").material = this.materialBlue
        // this.eauRural.getObjectByName("eau_base_06").position.z = 0
        this.eauRural.getObjectByName("Traitement_des_eaux").material = this.materialBlue
        this.eauRural.getObjectByName("eau_text_recup").material = this.materialYellow
        this.eauRural.getObjectByName("Traitement_des_eaux").position.z = 5

        this.eauRural.getObjectByName("eau_base_06").material = this.materialYellow
        this.eauRural.getObjectByName("eau_base_07").material = this.materialYellow
        this.eauRural.getObjectByName("eau_base_03_05").material = this.materialYellow
        this.eauRural.getObjectByName("eau_base_03_06").material = this.materialYellow
        this.eauRural.getObjectByName("eau_base_03_04").material = this.materialYellow
        this.eauRural.getObjectByName("eau_base_04_03").material = this.materialYellow
        this.eauRural.getObjectByName("eau_base_04_04").material = this.materialYellow
        this.eauRural.getObjectByName("zone_Eau_BWT").material = this.materialBlueOpacity




        this.hydroRural.add(
            this.fluxRuralModel.getObjectByName("H2-OK"),
            this.fluxRuralModel.getObjectByName("H2-text-01"),
            this.fluxRuralModel.getObjectByName("H2-text-01001"),
            this.fluxRuralModel.getObjectByName("multi-energie"),
            this.cloneProdMesh

        )
        this.hydroRural.getObjectByName("H2-OK").material = this.materialBlue
        this.hydroRural.getObjectByName("H2-text-01").material = this.materialBlue
        this.hydroRural.getObjectByName("H2-text-01001").material = this.materialBlue
        this.hydroRural.getObjectByName("multi-energie").material = this.materialBlueOpacity

        // console.log(this.fluxRuralModel);
        // console.log(this.fluxRuralModel);
        this.hydroRural.getObjectByName("H2-text-01").position.y = 6
        this.hydroRural.getObjectByName("H2-text-01").position.x = 220

        this.hydroRural.getObjectByName("H2-OK").position.x = 377
        this.hydroRural.getObjectByName("H2-OK").position.y = 6


        this.hydroRural.position.y = 0.1
        this.eauRural.position.y = 0.4

        this.gouvernanceRural.add(
            this.fluxRuralModel.getObjectByName("Gouvernance-02-01"),
            this.fluxRuralModel.getObjectByName("Gouvernance-Text-03"),
            this.fluxRuralModel.getObjectByName("Gouvernance-Text-02"),
            this.fluxRuralModel.getObjectByName("Gouvernance-01-01"),
            this.fluxRuralModel.getObjectByName("Gouvernance-01-02"),
            this.fluxRuralModel.getObjectByName("Gouvernance-01-03"),
            this.fluxRuralModel.getObjectByName("Gouvernance-02-02"),
            this.fluxRuralModel.getObjectByName("Gouvernance-01-04"),
            this.fluxRuralModel.getObjectByName("Gouvernance-Text-01-02"),
            this.fluxRuralModel.getObjectByName("Gouvernance-Text-01-02"),
            this.fluxRuralModel.getObjectByName("Gouvernance-Text-01-01")

        )
        this.gazRural.add(
            this.fluxRuralModel.getObjectByName("GAZ-OK"),
            this.fluxRuralModel.getObjectByName("Gaz-text-01"),
            this.fluxRuralModel.getObjectByName("Gaz-text-02"),
            this.methanProd

        )

        this.methanProd.position.x = 730
        this.methanProd.position.y = 41
        this.methanProd.position.z = 189


        this.gazRural.getObjectByName("GAZ-OK").material = this.materialBlue
        this.gazRural.getObjectByName("Gaz-text-01").material = this.materialBlue
        this.gazRural.getObjectByName("Gaz-text-02").material = this.materialBlue


        this.elecRural.getObjectByName("park").material = this.materialGrey
        this.elecRural.getObjectByName("park").position.y = 0.3

        this.elecRural.getObjectByName("Elec-Fleche-001").material = this.materialYellow
        this.elecRural.getObjectByName("Elec-Fleche-002").material = this.materialYellow
        this.elecRural.getObjectByName("Elec-Fleche-003").material = this.materialYellow
        this.elecRural.getObjectByName("Elec-Text-conso-03-auto-conso").material = this.materialBlue
        this.elecRural.getObjectByName("Elec-Text-produc-02").material = this.materialYellow
        this.elecRural.getObjectByName("Elec-Text-conso-01").material = this.materialBlue
        this.elecRural.getObjectByName("Elec_Fleche_alambic_04").material = this.materialBlue
        this.elecRural.getObjectByName("Elec_Fleche_alambic_auto_conso1").material = this.materialYellow
        this.elecRural.getObjectByName("Elec-Text-conso-02-auto-conso").material = this.materialYellow
        this.elecRural.getObjectByName("Elec-Text-conso-01-auto-conso").material = this.materialBlue
        this.elecRural.getObjectByName("Elec_Fleche_alambic_05").material = this.materialYellow
        this.elecRural.getObjectByName("Elec-picto-recyclage").material = this.materialGrey






        this.elecRural.getObjectByName("Elec-Fleche-004").material = this.materialYellow
        this.elecRural.getObjectByName("Elec-Text-conso-01001").material = this.materialBlue
        this.elecRural.getObjectByName("Elec-Text-conso-02").material = this.materialBlue
        this.elecRural.getObjectByName("Elec-picto-borne").material = this.materialGrey
        this.elecRural.getObjectByName("Elec-Text-produc-01").material = this.materialYellow
        this.elecRural.getObjectByName("Elec_Fleche_alambic_03_borne1").material = this.materialBlue

        this.elecRural.getObjectByName("Elec_Fleche_alambic_02_borne1").material = this.materialBlue




        this.batiRural.add(
            this.ruralModel.getObjectByName("Boite_caisson"),

            this.ruralModel.getObjectByName("Batiment_Mutualise"),
            this.ruralModel.getObjectByName("ombrieres_Covoit"),
            this.ruralModel.getObjectByName("ombrieres_Parking"),
            this.ruralModel.getObjectByName("Batiment_Logistique"),
            this.ruralModel.getObjectByName("Batiment_Industriel1"),
            this.ruralModel.getObjectByName("Entrepot_Mutualise"),
            this.ruralModel.getObjectByName("Batiment_Classique"),
            this.ruralModel.getObjectByName("Batiment_Industriel2"),
            this.ruralModel.getObjectByName("Batiment_methanyseur"),
            this.ruralModel.getObjectByName("Bornes_hydrogene"),
            this.ruralModel.getObjectByName("Batiment_Gare"),
            this.ruralModel.getObjectByName("Port"),
            this.ruralModel.getObjectByName("Batiment_Industriel3"),
            this.ruralModel.getObjectByName("Boite_lumiere"),
            this.fluxRuralModel.getObjectByName("espace-convivial"),
            this.fluxRuralModel.getObjectByName("espace-vert-pieton"),
            this.ruralModel.getObjectByName("Batiment_Electrolyseur"),


            // this.ruralModel.getObjectByName("ombrieres_Parking2")
            this.ruralModel.getObjectByName("Bati"),
        )
        // console.log(this.ruralModel)
        const matos = new THREE.MeshStandardMaterial({ color: 0xffffff, emissive: 0x250026, transparent: true, opacity: 0 })

        this.batiRural.getObjectByName("espace-vert-pieton").position.y = 0.1
        this.batiRural.getObjectByName("espace-vert-pieton").material = matos
        this.batiRural.getObjectByName("espace-convivial").position.y = 0.1
        this.batiRural.getObjectByName("espace-convivial").material = matos


        this.batiRural.getObjectByName("espace-vert-pieton").material.opacity = 0.5
        this.batiRural.getObjectByName("espace-convivial").material.opacity = 0.5
        this.scene.add(this.batiRural, this.spaceRural)
    }
    showScroll() {

        gsap.to(".navbar", {
            translateX: -150 + "%",
            ease: "back.out(1.7)",
            duration: 0.7
        })
        gsap.to(scrollClose, {
            opacity: 1,
            display: "flex",
            duration: 0.7
        })
        gsap.to(titleScroll, {
            opacity: 1,
            display: "flex",
            duration: 0.7
        })
        gsap.to(".scroll-box", {
            opacity: 1,
            display: "flex",

            duration: 0.7
        })
        gsap.to(".arrow_scroll", {
            opacity: 1,
            display: "flex",

            duration: 0.7
        })
        this.controls.enabled = false
        this.controls.autoRotate = false
    }
    scrollClose() {
        scrollClose.addEventListener("click", () => {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            this.body.style.overflow = "hidden"

            gsap.to(".scroll-box", {
                opacity: 0,
                display: "none",

                duration: 0.7
            })

            setTimeout(() => {
                this.zoomClick = true
            }, 1000);
            gsap.to(".arrow_scroll", {
                opacity: 0,
                display: "none",

                duration: 0.7
            })
            gsap.to(".navbar", {
                translateX: 0 + "%",
                ease: "back.out(1.7)",
                duration: 0.7
            })
            gsap.to(scrollClose, {
                opacity: 0,
                display: "none",
                duration: 0.4
            })
            gsap.to(titleScroll, {
                opacity: 0,
                display: "none",
                duration: 0.7
            })
            this.canvas.style.pointerEvents = "none"
            if (this.menuClick[0]) {
                gsap.to(this.controls.target, {
                    x: -40.3991442712137,
                    y: 37.751250394336324,
                    z: -107.82039437277317,
                    ease: "Power4.easeInOut",
                    duration: 3
                })
                gsap.to(this.camera.instance.position, {
                    x: -232.47739351551695,
                    y: 493.09564293646633,
                    z: 308.5191322700157,
                    ease: "Power4.easeInOut",
                    duration: 3,
                    onComplete: () => {
                        this.canvas.style.pointerEvents = "auto"
                    }
                })
            } else if (this.menuClick[1]) {
                gsap.to(this.camera.instance.position, {
                    x: -327.5617734895212,
                    y: 142.1617439683785,
                    z: -169.05707610207878,
                    ease: "Power4.easeInOut",
                    duration: 3,
                    onComplete: () => {
                        this.canvas.style.pointerEvents = "auto"
                    }
                })
                gsap.to(this.controls.target, {
                    x: -71.32866603431317,
                    y: -7.927482670905652,
                    z: -34.44436707769342,
                    ease: "Power4.easeInOut",
                    duration: 3
                })
            } else if (this.menuClick[2]) {
                gsap.to(this.controls.target, {
                    x: 6.581811359546185,
                    y: 4.16324682770597,
                    z: -96.9401376257985,
                    ease: "Power4.easeInOut",
                    duration: 3
                })
                gsap.to(this.camera.instance.position, {
                    x: -438.8564303022027,
                    y: 426.3679362253281,
                    z: 168.20765983685115,
                    ease: "Power4.easeInOut",
                    duration: 3,
                    onComplete: () => {
                        this.canvas.style.pointerEvents = "auto"
                    }
                })
            } else if (this.menuClick[3]) {
                gsap.to(this.controls.target, {
                    x: 6.581811359546185,
                    y: 4.16324682770597,
                    z: -96.9401376257985,
                    ease: "Power4.easeInOut",
                    duration: 3
                })
                gsap.to(this.camera.instance.position, {
                    x: -438.8564303022027,
                    y: 426.3679362253281,
                    z: 168.20765983685115,
                    ease: "Power4.easeInOut",
                    duration: 3,
                    onComplete: () => {
                        this.canvas.style.pointerEvents = "auto"
                    }
                })
            } else if (this.menuClick[4]) {
                gsap.to(this.controls.target, {
                    x: 6.581811359546185,
                    y: 4.16324682770597,
                    z: -96.9401376257985,
                    ease: "Power4.easeInOut",
                    duration: 3
                })
                gsap.to(this.camera.instance.position, {
                    x: -438.8564303022027,
                    y: 426.3679362253281,
                    z: 168.20765983685115,
                    ease: "Power4.easeInOut",
                    duration: 3,
                    onComplete: () => {
                        this.canvas.style.pointerEvents = "auto"
                    }
                })
            }

            this.controls.enabled = true
        })
    }



    setRaycast() {
        this.bubble = document.getElementById("bubble")
        this.scrollTitle = document.querySelector("#titleScroll")
        this.info = document.querySelector("#info")

        this.content = document.querySelector("#info_content")
        this.fluxContent = document.querySelector(".legendeFlux")
        this.banner = document.querySelector("#banner")
        this.banner.addEventListener("click", () => {
            window.scrollTo({
                top: 1000,
                behavior: "smooth"
            });
        })


        const bvhHelpersurbain = []
        const bvhHelperPeri = []
        const bvhHelperRural = []


        if (this.resources.items.urbainModel) {
            for (let i = 0; i < this.batiPeri.children.length; i++) {
                const object = this.batiPeri.children[i]
                const bvh = new THREE.Box3().setFromObject(object)
                this.bvhHelpersurbain = new THREE.Box3Helper(bvh)
                this.bvhHelpersurbain.material.visible = false
                this.bvhHelpersurbain.name = `urb${i}`
                this.scene.add(this.bvhHelpersurbain)
                bvhHelpersurbain.push(this.bvhHelpersurbain)
            }

        }
        if (this.resources.items.periModel) {
            for (let i = 0; i < this.batiUrbain.children.length; i++) {
                const object = this.batiUrbain.children[i]
                const bvh = new THREE.Box3().setFromObject(object)
                this.bvhHelperPeri = new THREE.Box3Helper(bvh)
                this.bvhHelperPeri.material.visible = false
                this.bvhHelperPeri.name = `peri${i}`
                this.scene.add(this.bvhHelperPeri)
                bvhHelperPeri.push(this.bvhHelperPeri)
            }

        }
        if (this.resources.items.ruralModel) {
            for (let i = 0; i < this.batiRural.children.length; i++) {
                const object = this.batiRural.children[i]
                const bvh = new THREE.Box3().setFromObject(object)
                this.bvhHelperRural = new THREE.Box3Helper(bvh)
                this.bvhHelperRural.material.visible = false
                this.bvhHelperRural.name = `rur${i}`
                this.scene.add(this.bvhHelperRural)
                bvhHelperRural.push(this.bvhHelperRural)
            }
        }





        document.addEventListener("mousedown", (event) => {
            const mouse = new THREE.Vector2(
                (event.clientX / window.innerWidth) * 2 - 1, -(event.clientY / window.innerHeight) * 2 + 1
            )
            let intersected = false
            const raycaster = new THREE.Raycaster()
            raycaster.setFromCamera(mouse, this.camera.instance)
            for (this.bvhHelpersurbain of bvhHelpersurbain) {
                if (raycaster.ray.intersectsBox(this.bvhHelpersurbain.box)) {
                    intersected = true
                    break
                }
            }
            for (this.bvhHelperPeri of bvhHelperPeri) {
                if (raycaster.ray.intersectsBox(this.bvhHelperPeri.box)) {
                    intersected = true
                    break
                }
            }
            for (this.bvhHelperRural of bvhHelperRural) {
                if (raycaster.ray.intersectsBox(this.bvhHelperRural.box)) {
                    intersected = true
                    break
                }
            }

            if (this.experience.current === "0") {
                if (this.menuClick[0]) {
                    if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb8") {
                        this.scrollTitle.innerHTML = "BATIMENT MUTUALISE"
                        this.zoomClick = false

                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[0][3].content
                            })

                        gsap.to(this.controls.target, {

                            x: -165.2025366988044,
                            y: -41.57007294145471,
                            z: 76.20287771928668,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -261.32921355734106,
                            y: 22.380090270021817,
                            z: -21.196980236924247,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
this.showScroll()
                        
                    } else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb2") {
                        this.scrollTitle.innerHTML = "PARKING A ETAGE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[0][1].content
                            })
                        gsap.to(this.controls.target, {
                            x: -192.5658741044705,
                            y: -40.59137953581351,
                            z: 16.896916006376827,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -81.22797756453276,
                            y: 46.499982775693596,
                            z: 127.11928641723972,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb7") {
                        this.scrollTitle.innerHTML = "BATIMENT INDUSTRIEL"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[0][0].content
                            })

                        gsap.to(this.controls.target, {
                            x: -197.7619519439515,
                            y: -1.4380006775062328,
                            z: 188.12331511030345,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -96.01761611004132,
                            y: 56.77303554515845,
                            z: 113.98165805617347,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()

                    } else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb4") {
                        this.scrollTitle.innerHTML = "ENTREPOT MUTUALISE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[0][2].content
                            })
                        gsap.to(this.controls.target, {
                            x: -131.61251469583235,
                            y: -7.5519874885717035,
                            z: 45.038890652157065,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -186.08249058066173,
                            y: 34.90739310174993,
                            z: -49.25543622691595,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                } else if (this.menuClick[1]) {
                    if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb9") {
                        this.scrollTitle.innerHTML = "BORNE MULTI ENERGIES"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[1][3].content
                            })
                        gsap.to(this.controls.target, {
                            x: 27.3289628057246,
                            y: 0.5979219614962727,
                            z: 23.315375475608636,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 68.71751645379905,
                            y: 28.648585097694454,
                            z: 67.13322008744686,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }  
                    else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb0") {
                        this.scrollTitle.innerHTML = "BORNES DE RECHARGE ÉLECTRIQUES"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[1][2].content
                            })
                        gsap.to(this.controls.target, {


                            x: 25.956268394374295,
                            y: -121.56215461959145,
                            z: -28.51594337632427,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 246.94960615457802,
                            y: 21.836425086093314,
                            z: 251.88135595894877,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb14") {
                        this.scrollTitle.innerHTML = "PRODUCTION LOCALE D'HYDROGÈNE PROPRE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[1][4].content
                            })
                        gsap.to(this.controls.target, {


                            x: 248.5397943086001,
                            y: -38.13106486228732,
                            z: 109.34155284168448,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 73.75293722225379,
                            y: 34.09539540863073,
                            z: 4.367394772779392,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb12") {
                        this.scrollTitle.innerHTML = "ECLAIRAGE INTELLIGENT"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[1][5].content
                            })
                        gsap.to(this.controls.target, {


                            x: 62.768136603035984,
                            y: -43.84700355332293,
                            z: -155.15300896571875,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 144.5110387438612,
                            y: 8.741803799009638,
                            z: -29.31910904380001,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb13") {
                        this.scrollTitle.innerHTML = "RECUPERATION DES EAUX PLUIVIALES"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[1][6].content
                            })
                        gsap.to(this.controls.target, {
                            x: 254.33048778768384,
                            y: -18.50585564197236,
                            z: -25.520835516511085,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 215.86977491101644,
                            y: 23.792308110020464,
                            z: -71.97578255935045,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb6") {
                        this.scrollTitle.innerHTML = "BATIMENT STANDARD"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[1][0].content
                            })

                        gsap.to(this.controls.target, {
                            x: 109.57862621556193,
                            y: 9.761189745648569,
                            z: -103.29830281825642,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 202.12550669513575,
                            y: 35.60053081733033,
                            z: -6.593892972514482,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    
                    
                    } else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb1") {
                        this.scrollTitle.innerHTML = "GRAND PARKING"
                        this.zoomClick = false

                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[1][1].content
                            })

                        gsap.to(this.controls.target, {
                            x: -200.06263583552007,
                            y: 2.0896722233179976,
                            z: -80.42117206608877,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -115.97539948758899,
                            y: 49.36608775738662,
                            z: 15.904404897611286,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()

                    }
                } else if (this.menuClick[2]) {
                    if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb9") {
                        this.scrollTitle.innerHTML = "BORNE MULTI ENERGIES"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[2][2].content
                            })
                        gsap.to(this.controls.target, {
                            x: 27.3289628057246,
                            y: 0.5979219614962727,
                            z: 23.315375475608636,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 68.71751645379905,
                            y: 28.648585097694454,
                            z: 67.13322008744686,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb8") {
                        this.scrollTitle.innerHTML = "BATIMENT MUTUALISE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[2][1].content
                            })

                        gsap.to(this.controls.target, {

                            x: -165.2025366988044,
                            y: -41.57007294145471,
                            z: 76.20287771928668,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -261.32921355734106,
                            y: 22.380090270021817,
                            z: -21.196980236924247,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
this.showScroll()
                        
                    } else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb4") {
                        this.scrollTitle.innerHTML = "ENTREPOT MUTUALISE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[2][0].content
                            })
                        gsap.to(this.controls.target, {
                            x: -131.61251469583235,
                            y: -7.5519874885717035,
                            z: 45.038890652157065,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -186.08249058066173,
                            y: 34.90739310174993,
                            z: -49.25543622691595,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                } else if (this.menuClick[3]) {
                    if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb8") {
                        this.scrollTitle.innerHTML = "BATIMENT MUTUALISE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[3][3].content
                            })

                        gsap.to(this.controls.target, {

                            x: -165.2025366988044,
                            y: -41.57007294145471,
                            z: 76.20287771928668,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -261.32921355734106,
                            y: 22.380090270021817,
                            z: -21.196980236924247,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
this.showScroll()
                        
                    } else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb5") {
                        this.scrollTitle.innerHTML = "BATIMENT INDUSTRIEL"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[3][0].content
                            })

                        gsap.to(this.controls.target, {
                            x: -71.54086017388357,
                            y: 28.154757226233343,
                            z: 132.59603331799164,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -126.18691011592452,
                            y: 55.479380951039445,
                            z: 96.03620728653192,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
                                this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb10") {
                        this.scrollTitle.innerHTML = "ZONE DE CONVIVIALITÉ"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[3][2].content
                            })

                            gsap.to(this.controls.target, {
                                x: -41.532540736756005,
                                y: -80.58089329741749,
                                z: -18.359774013229874,
                                ease: "Power4.easeInOut",
                                duration: 3
                            })
                            gsap.to(this.camera.instance.position, {
                                x: 100.59771553133237,
                                y: 37.944355354518535,
                                z: 230.01292762841143,
                                ease: "Power4.easeInOut",
                                duration: 3,
    
                                onComplete: () => {
                                    this.canvas.style.pointerEvents = "auto"
                                    gsap.to(document.documentElement, {
                                        scrollTop: this.banner.clientHeight
                                    })
                                    this.body.style.overflow = "inherit"
                                    this.body.style.overflowX = "hidden"
                                }
                            })
                            
                            this.showScroll()

                    }
                    else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb11") {
                        this.scrollTitle.innerHTML = "ESPACE VERT"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[3][1].content
                            })
                            gsap.to(this.controls.target, {
                                x: -69.21916534596538,
                                y: -4.222996587390614,
                                z: -42.53180200519435,
                                ease: "Power4.easeInOut",
                                duration: 3
                            })
                            gsap.to(this.camera.instance.position, {
                                x: -109.63648692937394,
                                y:41.821385304654186,
                                z: 4.997265461176333,
                                ease: "Power4.easeInOut",
                                duration: 3,
    
                                onComplete: () => {
                                    this.canvas.style.pointerEvents = "auto"
                                    gsap.to(document.documentElement, {
                                        scrollTop: this.banner.clientHeight
                                    })
                                    this.body.style.overflow = "inherit"
                                    this.body.style.overflowX = "hidden"
                                }
                            })
                            this.showScroll()

                        
                    }
                } else if (this.menuClick[4]) {


                    if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb8") {
                        this.scrollTitle.innerHTML = "BATIMENT MUTUALISE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[4][0].content
                            })

                        gsap.to(this.controls.target, {

                            x: -165.2025366988044,
                            y: -41.57007294145471,
                            z: 76.20287771928668,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -261.32921355734106,
                            y: 22.380090270021817,
                            z: -21.196980236924247,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
this.showScroll()
                        
                    } else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb9") {
                        this.scrollTitle.innerHTML = "BORNE MULTI ENERGIES"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[4][3].content
                            })
                        gsap.to(this.controls.target, {
                            x: 27.3289628057246,
                            y: 0.5979219614962727,
                            z: 23.315375475608636,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 68.71751645379905,
                            y: 28.648585097694454,
                            z: 67.13322008744686,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb4") {
                        this.scrollTitle.innerHTML = "ENTREPOT MUTUALISE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[4][1].content
                            })
                        gsap.to(this.controls.target, {
                            x: -131.61251469583235,
                            y: -7.5519874885717035,
                            z: 45.038890652157065,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -186.08249058066173,
                            y: 34.90739310174993,
                            z: -49.25543622691595,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelpersurbain.name == "urb2") {
                        this.scrollTitle.innerHTML = "PARKING A ETAGE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[0].zone[4][2].content
                            })
                        gsap.to(this.controls.target, {
                            x: -192.5658741044705,
                            y: -40.59137953581351,
                            z: 16.896916006376827,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -81.22797756453276,
                            y: 46.499982775693596,
                            z: 127.11928641723972,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }}


            } else if (this.experience.current === "1") {
                if (this.menuClick[0]) {
                    if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri2") {
                        this.scrollTitle.innerHTML = "BATIMENT MUTUALISE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[1].zone[0][4].content
                            })

                        gsap.to(this.controls.target, {
                            x: -45.892863138033995,
                            y: 12.386780293856742,
                            z: -109.81502706035954,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -191.4840872775547,
                            y: 30.079948531502616,
                            z: -41.54910676706196,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
this.showScroll()
                        
                    } else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri1") {
                        this.scrollTitle.innerHTML = "PARKING A ETAGE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[1].zone[0][2].content
                            })
                        gsap.to(this.controls.target, {
                            x: -314.49487096276715,
                            y: 8.586575109406276,
                            z: -62.41883489194921,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -399.44240826957105,
                            y: 26.27974334703762,
                            z: 74.11305268544092,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri0") {
                        this.scrollTitle.innerHTML = "BATIMENT INDUSTRIEL"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[1].zone[0][1].content
                            })

                        gsap.to(this.controls.target, {
                            x: 516.2111674639973,
                            y: 30.74608828187939,
                            z: -114.47346220640404,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 448.4405696648113,
                            y: 104.69764829251848,
                            z: -11.8558281546469,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri6") {
                        this.scrollTitle.innerHTML = "ENTREPOT MUTUALISE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[1].zone[0][3].content
                            })
                        gsap.to(this.controls.target, {
                            x: -385.4055929216697,
                            y: 2.763174842297884,
                            z: -137.7288329111503,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -423.7287733056327,
                            y: 26.85195095324648,
                            z: -82.76965327611764,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri3") {
                        this.scrollTitle.innerHTML = "BATIMENT LOGISTIQUE"
                        this.zoomClick = false

                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[1].zone[0][0].content
                            })
                        gsap.to(this.controls.target, {
                            x: 47.93360030239726,
                            y: 27.12591451939159,
                            z: -75.02664214586986,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -21.282776771902398,
                            y: 85.19384871413999,
                            z: -20.580901051478868,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                } else if (this.menuClick[1]) {
                    if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri4") {
                        this.scrollTitle.innerHTML = "BATIMENT STANDARD"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[1].zone[1][1].content
                            })
                        gsap.to(this.controls.target, {
                            x: -253.29504217534458,
                            y: 20.069389820688937,
                            z: 223.2183886916281,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -158.67373316373536,
                            y: 32.85281967438994,
                            z: 155.80482083002957,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri11") {
                        this.scrollTitle.innerHTML = "RÉCUPERATION DES EAUX PLUIVIALES"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[1].zone[1][7].content
                            })
                        gsap.to(this.controls.target, {
                            x: 86.34595839863294,
                            y: -1.2329508935182598,
                            z: 123.45493588865806,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 30.81090169918771,
                            y: 21.288572702245403,
                            z: 126.39406030162033,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri14") {
                        this.scrollTitle.innerHTML = "ECLAIRAGE INTELLIGENT"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[1].zone[1][6].content
                            })
                        gsap.to(this.controls.target, {
                            x: -218.1960541343772,
                            y: -2.9432489525076924,
                            z: -122.50959447432723,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -191.0700063477857,
                            y: 7.0486912597769305,
                            z: -46.17766959078715,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri15") {
                        this.scrollTitle.innerHTML = "BORNES DE RECHARGE ÉLECTRIQUES"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[1].zone[1][3].content
                            })
                        gsap.to(this.controls.target, {
                            x: -247.8306024543607,
                            y: -33.62846353370362,
                            z: -9.930994407882137,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -145.1739477950561,
                            y: 21.646992913408866,
                            z: 228.66837647513717,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri13") {
                        this.scrollTitle.innerHTML = "GRAND PARKING"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[1].zone[1][2].content
                            })
                        gsap.to(this.controls.target, {
                            x: 85.28269460276412,
                            y: -178.40323361338386,
                            z: -365.34943848899337,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 468.1126834973382,
                            y: 59.539762755873056,
                            z: -11.241675457648228,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri10") {
                        this.scrollTitle.innerHTML = "PRODUCTION D'HYDROGENE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[1].zone[1][5].content
                            })
                        gsap.to(this.controls.target, {
                            x: 176.59465579692707,
                            y: -96.70754260853761,
                            z: 437.8911921182058,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 617.6571737086449,
                            y: 46.70688365091591,
                            z: 221.1924863935349,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    
                    else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri3") {
                        this.scrollTitle.innerHTML = "BATIMENT LOGISTIQUE"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[1][0].content
                        })
                        gsap.to(this.controls.target, {
                            x: 47.93360030239726,
                            y: 27.12591451939159,
                            z: -75.02664214586986,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -21.282776771902398,
                            y: 85.19384871413999,
                            z: -20.580901051478868,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }

                    else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri5") {
                        this.scrollTitle.innerHTML = "BORNE MULTI ENERGIES"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[1][4].content
                        })
                        gsap.to(this.controls.target, {
                            x: -10.530379377199921,
                            y: 1.019243089843052,
                            z: 163.3554315335363,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -66.22371404801473,
                            y: 68.69763344998394,
                            z: 211.9365315640729,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                } else if (this.menuClick[2]) {
                    if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri2") {
                        this.scrollTitle.innerHTML = "BATIMENT MUTUALISE"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[2][3].content
                        })
                        gsap.to(this.controls.target, {
                            x: -45.892863138033995,
                            y: 12.386780293856742,
                            z: -109.81502706035954,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -191.4840872775547,
                            y: 30.079948531502616,
                            z: -41.54910676706196,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri5") {
                        this.scrollTitle.innerHTML = "BORNE MULTI ENERGIES"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[2][4].content
                        })
                        gsap.to(this.controls.target, {
                            x: -10.530379377199921,
                            y: 1.019243089843052,
                            z: 163.3554315335363,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -66.22371404801473,
                            y: 68.69763344998394,
                            z: 211.9365315640729,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri7") {
                        this.scrollTitle.innerHTML = "INFRASTRUCTURE FERROVIAIRE"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[2][1].content
                        })
                        gsap.to(this.controls.target, {
                            x: 688.064428944377,
                            y: 24.715468140749433,
                            z: -31.009254311084423,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 810.6505197641337,
                            y: 62.925013202082184,
                            z: 89.62208878141924,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri9") {
                        this.scrollTitle.innerHTML = "INFRASTRUCTURE PORTUAIRE"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[2][0].content
                        })
                        gsap.to(this.controls.target, {
                            x: 335.1782376871163,
                            y: -95.018953153665,
                            z: 314.9810192171811,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 50.07884227562056,
                            y: 197.13416918262402,
                            z: 541.5722752580152,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri8") {
                        this.scrollTitle.innerHTML = "INFRASTRUCTURE PORTUAIRE"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[2][0].content
                        })
                        gsap.to(this.controls.target, {
                            x: 335.1782376871163,
                            y: -95.018953153665,
                            z: 314.9810192171811,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 50.07884227562056,
                            y: 197.13416918262402,
                            z: 541.5722752580152,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri6") {
                        this.scrollTitle.innerHTML = "ENTREPOT MUTUALISE"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[2][2].content
                        })
                        gsap.to(this.controls.target, {
                            x: -385.4055929216697,
                            y: 2.763174842297884,
                            z: -137.7288329111503,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -423.7287733056327,
                            y: 26.85195095324648,
                            z: -82.76965327611764,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                } else if (this.menuClick[3]) {
                    if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri2") {
                        this.scrollTitle.innerHTML = "BATIMENT MUTUALISE"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[3][3].content
                        })
                        gsap.to(this.controls.target, {
                            x: -45.892863138033995,
                            y: 12.386780293856742,
                            z: -109.81502706035954,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -191.4840872775547,
                            y: 30.079948531502616,
                            z: -41.54910676706196,
                            ease: "Power4.easeInOut",
                            duration: 3,
                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri12") {
                        this.scrollTitle.innerHTML = "BATIMENT INDUSTRIEL"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[3][0].content
                        })
                        gsap.to(this.controls.target, {
                            x: 216.56616274928075,
                            y: 7.924426405868014,
                            z: 253.33957311183835,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 363.81974058618084,
                            y: 129.19168808896154,
                            z: -11.071844092150485,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri16") {
                        this.scrollTitle.innerHTML = "ESPACE DE CONVIVIALITÉ"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[3][2].content
                        })
                        gsap.to(this.controls.target, {
                            x: -54.34,
                            y: -27.89,
                            z: -95.22,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 39.06,
                            y: 45.30,
                            z: 22.79,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri17") {
                        this.scrollTitle.innerHTML = "ESPACE VERT"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[3][1].content
                        })
                        gsap.to(this.controls.target, {
                            x: -169.40,
                            y: -124.11,
                            z: -126.32,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -284.07,
                            y: 31.47,
                            z: 51.72,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                }
                else if (this.menuClick[3]) {
                    if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri2") {
                        this.scrollTitle.innerHTML = "BATIMENT MUTUALISE"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[3][3].content
                        })
                        gsap.to(this.controls.target, {
                            x: -45.892863138033995,
                            y: 12.386780293856742,
                            z: -109.81502706035954,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -191.4840872775547,
                            y: 30.079948531502616,
                            z: -41.54910676706196,
                            ease: "Power4.easeInOut",
                            duration: 3,
                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } 
                    else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri6") {
                        this.scrollTitle.innerHTML = "ENTREPOT MUTUALISE"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[2][2].content
                        })
                        gsap.to(this.controls.target, {
                            x: -385.4055929216697,
                            y: 2.763174842297884,
                            z: -137.7288329111503,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -423.7287733056327,
                            y: 26.85195095324648,
                            z: -82.76965327611764,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                }
                else if (this.menuClick[4]) {
                    if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri2") {
                        this.scrollTitle.innerHTML = "BATIMENT MUTUALISE"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[4][0].content
                        })
                        gsap.to(this.controls.target, {
                            x: -45.892863138033995,
                            y: 12.386780293856742,
                            z: -109.81502706035954,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -191.4840872775547,
                            y: 30.079948531502616,
                            z: -41.54910676706196,
                            ease: "Power4.easeInOut",
                            duration: 3,
                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } 
                    else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri1") {
                        this.scrollTitle.innerHTML = "PARKING A ETAGE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[1].zone[4][2].content
                            })
                        gsap.to(this.controls.target, {
                            x: -314.49487096276715,
                            y: 8.586575109406276,
                            z: -62.41883489194921,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -399.44240826957105,
                            y: 26.27974334703762,
                            z: 74.11305268544092,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri5") {
                        this.scrollTitle.innerHTML = "BORNE MULTI ENERGIES"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[4][3].content
                        })
                        gsap.to(this.controls.target, {
                            x: -10.530379377199921,
                            y: 1.019243089843052,
                            z: 163.3554315335363,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -66.22371404801473,
                            y: 68.69763344998394,
                            z: 211.9365315640729,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelperPeri.name == "peri6") {
                        this.scrollTitle.innerHTML = "ENTREPOT MUTUALISE"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[1].zone[4][1].content
                        })
                        gsap.to(this.controls.target, {
                            x: -385.4055929216697,
                            y: 2.763174842297884,
                            z: -137.7288329111503,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -423.7287733056327,
                            y: 26.85195095324648,
                            z: -82.76965327611764,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                }
            } else if (this.experience.current === "2") {
                if (this.menuClick[0]) {
                    if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur1") {
                        this.scrollTitle.innerHTML = "BATIMENT MUTUALISE"
                        
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[0][4].content
                        })
                        gsap.to(this.controls.target, {
                            x: 226.41436224054388,
                            y: -30.285005990194506,
                            z: 126.89032271170295,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 37.86451399706965,
                            y: 42.55273073157329,
                            z: 213.91730328101312,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
this.showScroll()
                        
                    } else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur4") {
                        this.scrollTitle.innerHTML = "BATIMENT LOGISTIQUE"
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[0][0].content
                        })
                        gsap.to(this.controls.target, {
                            x: 607.262470405073,
                            y: -23.166792242677193,
                            z: -126.0933655189953,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 673.0835271118883,
                            y: 48.44197837558528,
                            z: 173.65556859084847,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur5") {
                        this.scrollTitle.innerHTML = "BATIMENT INDUSTRIEL"
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[0][1].content
                        })
                        gsap.to(this.controls.target, {
                            x: -23.44327868330619,
                            y: 9.110188343815954,
                            z: -88.62029664016258,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -143.5754911316983,
                            y: 80.03903204149994,
                            z: 96.31299512534231,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur6") {
                        this.scrollTitle.innerHTML = "ENTREPÔT MUTUALISE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[2].zone[0][3].content
                            })
                        gsap.to(this.controls.target, {
                            x: -373.01843682532405,
                            y: 3.813071472460965,
                            z: 171.70293317313647,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -493.15196504191374,
                            y: 45.4166042622751,
                            z: 227.15111962474646,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur2") {
                        this.scrollTitle.innerHTML = "PARKING DE COVOITURAGE"
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[0][2].content
                        })
                        gsap.to(this.controls.target, {
                            x: 134.31086323919712,
                            y: -66.61587701492935,
                            z: 129.40039013314922,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -15.649118647236577,
                            y: 26.491359292399054,
                            z: 241.43552861671589,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                } else if (this.menuClick[1]) {

                    if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur7") {
                        this.scrollTitle.innerHTML = "BATIMENT STANDARD"
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[1][1].content
                        })
                        gsap.to(this.controls.target, {
                            x: -412.3532573458817,
                            y: -81.59276896763653,
                            z: 377.1206653039067,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -172.08345360745122,
                            y: 55.42636591217445,
                            z: 211.01520228079997,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } 
                    else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur3") {
                        this.scrollTitle.innerHTML = "GRAND PARKING"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[1][2].content
                        })
                        gsap.to(this.controls.target, {
                            x: -149.92550915973612,
                            y: -250.15891618856355,
                            z: -444.7658792743123,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -513.4989325273436,
                            y: 45.57398101650662,
                            z: 22.19031791611104,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur17") {
                        this.scrollTitle.innerHTML = "METHANISEUR"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[1][6].content
                        })
                        gsap.to(this.controls.target, {
                            x: 671.1232158890707,
                            y: -56.599375177686504,
                            z:41.854214884086296,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 853.1687271488364,
                            y: 77.43833777919133,
                            z:295.2982399189475,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur14") {
                        this.scrollTitle.innerHTML = "ECLAIRAGE INTELLIGENT"
                        this.zoomClick = false

                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[1][7].content
                        })
                        gsap.to(this.controls.target, {
                            x: -206.7065633230327,
                            y: -39.94192060051913,
                            z: -26.698469753963526,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -188.997783024583,
                            y: 8.990591127757675,
                            z:107.03288163105836,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur2") {
                        this.scrollTitle.innerHTML = "BORNES DE RECHARGE ÉLECTRIQUES"
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[1][3].content
                        })
                        gsap.to(this.controls.target, {
                            x: 134.31086323919712,
                            y: -66.61587701492935,
                            z: 129.40039013314922,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -15.649118647236577,
                            y: 26.491359292399054,
                            z: 241.43552861671589,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    
                }
                    else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur0") {
                        this.scrollTitle.innerHTML = "RÉCUPERATION DES EAUX PLUIVIALES"
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[1][8].content
                        })
                        gsap.to(this.controls.target, {
                            x: -21.70000429425474,
                            y: -75.41167126916673,
                            z: -95.79692797039651,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 173.40613524409582,
                            y: 29.354439695016836,
                            z: -10.906664528836245,
                            ease: "Power4.easeInOut",
                            duration: 3,
                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur9") {
                        this.scrollTitle.innerHTML = "PRODUCTION LOCALE D'HYDROGENE"
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[1][5].content
                        })
                        gsap.to(this.controls.target, {
                            x: 123.43566536046313,
                            y: -59.02372335821236,
                            z: 202.8535620658643,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 321.4546214563261,
                            y: 55.45402832542586,
                            z: 337.7859970591803,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur10") {
                        this.scrollTitle.innerHTML = "BORNE MULTI ENERGIES"
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[1][4].content
                        })
                        gsap.to(this.controls.target, {
                            x: 183.5997303054051,
                            y: -34.68972090532827,
                            z: 212.3938479273343,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 340.1594704203821,
                            y: 48.22166321981295,
                            z: 88.29134620795398,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur8") {
                        this.scrollTitle.innerHTML = "BATIMENT LOGISTIQUE"
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[1][0].content
                        })
                        gsap.to(this.controls.target, {
                            x: 53.93671315070343,
                            y: 46.301012406724595,
                            z: -250.41592841963057,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 81.19838439223955,
                            y: 67.84275922147319,
                            z: -201.50013929906464,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                } else if (this.menuClick[2]) {
                    if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur12") {
                        this.scrollTitle.innerHTML = "INFRASTRUCTURE PORTUAIRE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[2].zone[2][0].content
                            })
                        gsap.to(this.controls.target, {
                            x: 336.2372175592759,
                            y: -41.49816249891914,
                            z: 264.40636408525717,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 585.6616578571357,
                            y: 138.3642742174902,
                            z: 609.2080924053862,
                            ease: "Power4.easeInOut",
                            duration: 3,
                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur1") {
                        this.scrollTitle.innerHTML = "BATIMENT MUTUALISE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[2].zone[2][3].content
                            })

                        gsap.to(this.controls.target, {
                            x: 226.41436224054388,
                            y: -30.285005990194506,
                            z: 126.89032271170295,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 37.86451399706965,
                            y: 42.55273073157329,
                            z: 213.91730328101312,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
this.showScroll()
                        
                    } else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur6") {
                        this.scrollTitle.innerHTML = "ENTREPÔT MUTUALISE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[2].zone[2][2].content
                            })
                        gsap.to(this.controls.target, {
                            x: -373.01843682532405,
                            y: 3.813071472460965,
                            z: 171.70293317313647,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -493.15196504191374,
                            y: 45.4166042622751,
                            z: 227.15111962474646,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur11") {
                        this.scrollTitle.innerHTML = "INFRASTRUCTURE FERROVIAIRE"
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[2][1].content
                        })
                        gsap.to(this.controls.target, {
                            x: 249.618893259043,
                            y: -123.16124823447899,
                            z: -334.80347220214406,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -200.04715028084948,
                            y: 101.09494129400639,
                            z: -597.9635160851398,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    } else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur10") {
                        this.scrollTitle.innerHTML = "BORNE MULTI ENERGIES"
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[2][4].content
                        })
                        gsap.to(this.controls.target, {
                            x: 183.5997303054051,
                            y: -34.68972090532827,
                            z: 212.3938479273343,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 340.1594704203821,
                            y: 48.22166321981295,
                            z: 88.29134620795398,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                } else if (this.menuClick[3]) {
                     if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur1") {
                        this.scrollTitle.innerHTML = "BATIMENT MUTUALISE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[2].zone[3][3].content
                            })

                        gsap.to(this.controls.target, {
                            x: 226.41436224054388,
                            y: -30.285005990194506,
                            z: 126.89032271170295,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 37.86451399706965,
                            y: 42.55273073157329,
                            z: 213.91730328101312,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
this.showScroll()
                        
                    } else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur13") {
                        this.scrollTitle.innerHTML = "BATIMENT INDUSTRIEL"
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[3][0].content
                        })

                        gsap.to(this.controls.target, {
                            x: 519.77314083906,
                            y: 36.43990268079887,
                            z: 184.56480658002866,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 601.685832097271,
                            y: 61.73067318803594,
                            z: 78.56939417395995,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }

                    else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur16") {
                        this.scrollTitle.innerHTML = "ESPACE VERT"
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[3][1].content
                        })

                        gsap.to(this.controls.target, 
                            {
                            x: -187.66675867009607,
                            y: -147.46953646413525,
                            z: 32.05646387779284,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -23.966514534543677,
                            y: 38.81822968672947,
                            z: 320.3456030850074,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur15") {
                        this.scrollTitle.innerHTML = "ZONE DE CONVIVIALITÉ"
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[3][2].content
                        })

                        gsap.to(this.controls.target, {
                            x: -1.67472607219816,
                            y: -68.03785386853842,
                            z: -22.826044635203033,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -211.24300480648546,
                            y: 79.5575299395094,
                            z: 151.05604892968032,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }

                }
                else if (this.menuClick[4]) {
                    if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur1") {
                        this.scrollTitle.innerHTML = "BATIMENT MUTUALISE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[2].zone[4][0].content
                            })

                        gsap.to(this.controls.target, {
                            x: 226.41436224054388,
                            y: -30.285005990194506,
                            z: 126.89032271170295,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 37.86451399706965,
                            y: 42.55273073157329,
                            z: 213.91730328101312,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
this.showScroll()
                        
                    } 
                    else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur2") {
                        this.scrollTitle.innerHTML = "PARKING DE COVOITURAGE"
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[4][2].content
                        })
                        gsap.to(this.controls.target, {
                            x: 134.31086323919712,
                            y: -66.61587701492935,
                            z: 129.40039013314922,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -15.649118647236577,
                            y: 26.491359292399054,
                            z: 241.43552861671589,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    
                }
                    else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur10") {
                        this.scrollTitle.innerHTML = "BORNE MULTI ENERGIES"
                        this.zoomClick = false
                        fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.content.innerHTML = data.model[2].zone[4][3].content
                        })
                        gsap.to(this.controls.target, {
                            x: 183.5997303054051,
                            y: -34.68972090532827,
                            z: 212.3938479273343,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: 340.1594704203821,
                            y: 48.22166321981295,
                            z: 88.29134620795398,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                    else if (this.zoomClick && intersected && this.bvhHelperRural.name == "rur6") {
                        this.scrollTitle.innerHTML = "ENTREPÔT MUTUALISE"
                        this.zoomClick = false
                        fetch(Data)
                            .then((response) => response.json())
                            .then((data) => {
                                this.content.innerHTML = data.model[2].zone[2][2].content
                            })
                        gsap.to(this.controls.target, {
                            x: -373.01843682532405,
                            y: 3.813071472460965,
                            z: 171.70293317313647,
                            ease: "Power4.easeInOut",
                            duration: 3
                        })
                        gsap.to(this.camera.instance.position, {
                            x: -493.15196504191374,
                            y: 45.4166042622751,
                            z: 227.15111962474646,
                            ease: "Power4.easeInOut",
                            duration: 3,

                            onComplete: () => {
                                this.canvas.style.pointerEvents = "auto"
                                gsap.to(document.documentElement, {
                                    scrollTop: this.banner.clientHeight
                                })
                                  this.body.style.overflow = "inherit"
        this.body.style.overflowX = "hidden"
                            }
                        })
                        this.showScroll()
                    }
                }
            }
        })
        document.addEventListener("mousemove", (event) => {
            const mouse = new THREE.Vector2(
                (event.clientX / window.innerWidth) * 2 - 1, -(event.clientY / window.innerHeight) * 2 + 1
            )
            this.inters = false
            const raycaster = new THREE.Raycaster()
            raycaster.setFromCamera(mouse, this.camera.instance)
            for (this.bvhHelpersurbain of bvhHelpersurbain) {
                if (raycaster.ray.intersectsBox(this.bvhHelpersurbain.box)) {
                    this.inters = true
                    break
                }
            }
            for (this.bvhHelperPeri of bvhHelperPeri) {
                raycaster.far = 1
                if (raycaster.ray.intersectsBox(this.bvhHelperPeri.box)) {
                    this.inters = true
                    break
                }
            }
            for (this.bvhHelperRural of bvhHelperRural) {
                if (raycaster.ray.intersectsBox(this.bvhHelperRural.box)) {
                    this.inters = true
                    break
                }
            }
            // this.canvas.style.cursor = "none"


            if (this.experience.current === "0") {
                // console.log(this.bvhHelpersurbain.name);
                if (this.menuClick[0]) {
                    if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb2") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Parking à étage"
                    } else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb7") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Bâtiment Industriel"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb4") {
                        this.bubble.innerHTML = "Entrepôt mutualisé"
                        this.bubble.style.opacity = 1
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb8") {
                        this.bubble.innerHTML = "Batiment mutualisé"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    } else {
                        this.bubble.style.opacity = 0
                        this.canvas.style.cursor = "grab"
                    }
                } else if (this.menuClick[1]) {
                     if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb9") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Borne Multi énergies"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb6") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Bâtiment Standard"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb1") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Grand Parking"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb0") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Bornes de recharge électriques"
                        this.canvas.style.cursor = "pointer"
                    }
                    else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb14") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Production locale d'hydrogène propre"
                        this.canvas.style.cursor = "pointer"
                    }
                    else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb12") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Eclairage Intelligent"

                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb13") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Récuperation des eaux pluiviales"
                        this.canvas.style.cursor = "pointer"
                    } else {
                        this.bubble.style.opacity = 0
                        this.canvas.style.cursor = "grab"
                    }
                } else if (this.menuClick[2]) {
                    if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb8") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Batiment mutualisé"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb4") {
                        this.bubble.innerHTML = "Entrepot mutualisé"
                        this.bubble.style.opacity = 1
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb9") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Borne Multi énergies"
                        this.canvas.style.cursor = "pointer"
                    } else {
                        this.bubble.style.opacity = 0
                        this.canvas.style.cursor = "grab"
                    }
                } else if (this.menuClick[3]) {
                    if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb8") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Batiment mutualisé"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb5") {
                        this.bubble.innerHTML = "Batiment Industriel"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    }
                    else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb10") {
                        this.bubble.innerHTML = "Zone de convivialité"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    }
                    else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb11") {
                        this.bubble.innerHTML = "Espace vert"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    } else {
                        this.bubble.style.opacity = 0
                        this.canvas.style.cursor = "grab"
                    }
                } else if (this.menuClick[4]) {
                    if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb8") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Batiment mutualisé"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb2") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Parking à étage"
                        this.canvas.style.cursor = "pointer"

                    } else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb4") {
                        this.bubble.innerHTML = "Entrepot mutualisé"
                        this.bubble.style.opacity = 1
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelpersurbain.name == "urb9") {

                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Borne Multi énergies"
                        this.canvas.style.cursor = "pointer"
                    } else {
                        this.bubble.style.opacity = 0
                        this.canvas.style.cursor = "grab"
                    }
                }
            } else if (this.experience.current === "1") {
                // console.log(this.bvhHelperPeri.name);

                if (this.menuClick[0]) {
                    if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri1") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Parking à étage"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri2") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Bâtiment Mutualisé"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri6") {
                        this.bubble.innerHTML = "Entrepot mutualisé"
                        this.bubble.style.opacity = 1
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri0") {
                        this.bubble.innerHTML = "Batiment Industriel"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    } else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri3") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Batiment Logistique"
                        this.canvas.style.cursor = "pointer"
                    } 
                   
                    else {
                        this.bubble.style.opacity = 0
                        this.canvas.style.cursor = "grab"
                    }
                } else if (this.menuClick[1]) {
                    if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri3") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Bâtiment Logistique"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri4") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Bâtiment Standard" // bat rond
                        this.canvas.style.cursor = "pointer"
                    }
                    else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri14") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Eclairage Intelligent" // bat rond
                        this.canvas.style.cursor = "pointer"
                    }
                    else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri15") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Bornes de recharge électriques" // bat rond
                        this.canvas.style.cursor = "pointer"
                    }
                    else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri13") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Grand Parking" // bat rond
                        this.canvas.style.cursor = "pointer"
                    }
                    else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri11") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Récuperation des eaux pluiviales"
                        this.canvas.style.cursor = "pointer"
                    } 
                    else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri10") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Production locale d'hydrogene"
                        this.canvas.style.cursor = "pointer"
                    } 
                    else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri5") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Borne Multi énergies"
                        this.canvas.style.cursor = "pointer"
                    }
                    else {
                        this.bubble.style.opacity = 0
                        this.canvas.style.cursor = "grab"
                    }
                } else if (this.menuClick[2]) {
                    if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri2") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Batiment Mutualisé"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri5") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Borne Multi énergies"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri8") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Infrastructure portuaire"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri9") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Infrastructure portuaire"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri6") {
                        this.bubble.innerHTML = "Entrepot mutualisé"
                        this.bubble.style.opacity = 1
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri7") {
                        this.bubble.innerHTML = "Infrastructure ferroviaire"
                        this.bubble.style.opacity = 1
                        this.canvas.style.cursor = "pointer"
                    } else {
                        this.bubble.style.opacity = 0
                        this.canvas.style.cursor = "grab"
                    }
                } else if (this.menuClick[3]) {
                    if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri2") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Batiment Mutualisé"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri12") {
                        this.bubble.innerHTML = "Batiment Industriel"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    } 
                    else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri16") {
                        this.bubble.innerHTML = "Zone de convivialité"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    }
                    else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri17") {
                        this.bubble.innerHTML = "Espace Vert"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    }
                    else {
                        this.bubble.style.opacity = 0
                        this.canvas.style.cursor = "grab"
                    }
                }
                else if (this.menuClick[4]) {
                    if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri2") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Batiment Mutualisé"
                        this.canvas.style.cursor = "pointer"
                    } 
                   else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri1") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Parking à étage"
                        this.canvas.style.cursor = "pointer"
                    } 
else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri6") {
                        this.bubble.innerHTML = "Entrepot mutualisé"
                        this.bubble.style.opacity = 1
                        this.canvas.style.cursor = "pointer"
                    }
 else if (this.zoomClick && this.inters && this.bvhHelperPeri.name == "peri5") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Borne Multi énergies"
                        this.canvas.style.cursor = "pointer"
                    }else {
                        this.bubble.style.opacity = 0
                        this.canvas.style.cursor = "grab"
                    }
                }

            } else if (this.experience.current === "2") {
                // console.log(this.bvhHelperRural.name);

                if (this.menuClick[0]) {
                    if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur2") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Parking Covoiturage"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur4") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Batiment Logistique"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur5") {
                        this.bubble.innerHTML = "Batiment Industriel"
                        this.bubble.style.opacity = 1
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur1") {
                        this.bubble.innerHTML = "Batiment Mutualisé"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    } else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur6") {
                        this.bubble.innerHTML = "Entrepot Mutualisé"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    } else {
                        this.bubble.style.opacity = 0
                        this.canvas.style.cursor = "grab"
                    }
                } else if (this.menuClick[1]) {
                    if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur3") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Grand Parking"
                        this.canvas.style.cursor = "pointer"
                    } 
                    else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur2") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Bornes de recharge électriques"
                        this.canvas.style.cursor = "pointer"
                    } 
                    else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur7") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Batiment Standard"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur8") {
                        this.bubble.innerHTML = "Batiment Logistique"
                        this.bubble.style.opacity = 1
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur9") {
                        this.bubble.innerHTML = "Production locale d’hydrogène"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    } else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur10") {
                        this.bubble.innerHTML = "Borne Multi énergies"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    }
                    else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur17") {
                        this.bubble.innerHTML = "Méthaniseur"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    } 
                    else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur14") {
                        this.bubble.innerHTML = "Eclairage Intelligent"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    } 
                    else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur0") {
                        this.bubble.innerHTML = "Récuperation des eaux pluiviales"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    } else {
                        this.bubble.style.opacity = 0
                        this.canvas.style.cursor = "grab"
                    }
                } else if (this.menuClick[2]) {
                    if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur6") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Entrepot mutualisé"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur1") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Batiment Mutualisé"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur11") {
                        this.bubble.innerHTML = "Infrastructure ferroviaire"
                        this.bubble.style.opacity = 1
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur12") {
                        this.bubble.innerHTML = "Infrastructure portuaire"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    } else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur10") {
                        this.bubble.innerHTML = "Borne Multi énergies"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    } else {
                        this.bubble.style.opacity = 0
                        this.canvas.style.cursor = "grab"
                    }
                } else if (this.menuClick[3]) {
                    if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur13") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Batiment Industriel"
                        this.canvas.style.cursor = "pointer"
                    } else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur1") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Batiment Mutualisé"
                        this.canvas.style.cursor = "pointer"
                    } 
                    else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur15") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Zone de convivialité"
                        this.canvas.style.cursor = "pointer"
                    }
                    else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur16") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Espace vert"
                        this.canvas.style.cursor = "pointer"
                    }
                     else {
                        this.bubble.style.opacity = 0
                        this.canvas.style.cursor = "grab"
                    }
                } else if (this.menuClick[4]) {
                      if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur10") {
                        this.bubble.innerHTML = "Borne Multi énergies"
                        this.canvas.style.cursor = "pointer"
                        this.bubble.style.opacity = 1
                    } else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur6") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Entrepôt mutualisé"
                        this.canvas.style.cursor = "pointer"
                    } 
                    else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur2") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Parking covoiturage"
                        this.canvas.style.cursor = "pointer"
                    } 
                    else if (this.zoomClick && this.inters && this.bvhHelperRural.name == "rur1") {
                        this.bubble.style.opacity = 1
                        this.bubble.innerHTML = "Batiment Mutualisé"
                        this.canvas.style.cursor = "pointer"
                    }

                    else {
                        this.bubble.style.opacity = 0
                        this.canvas.style.cursor = "grab"
                    }
                }

            }
        })
    }
    setLegendeFlux() {
        gsap.to(".title", {
            width: this.legendeFLuxExist ? 25 + '%' : 15 + '%',
        })

        gsap.to(".legendeFlux", {
            translateX: this.legendeFLuxExist ? 0 : 150 + '%',
        })


    }
    showLoader() {
        gsap.to(".root", {
            opacity: 1,
            display: "flex"
        })
    }
    hideLoader() {
        gsap.to(".root", {
            opacity: 0,
            display: "none",
            delay: 1
        })
    }

    whitePassage() {
        // const color = new THREE.Color(0xffffff) // Crée un objet de couleur blanc
        // color.luminosity = 10 // Réduit la luminosité à 80% (blanc légèrement grisé)
        // Parcourir les enfants du modèle 3D pour changer leur material
        if (this.resources.items.periModel) {
            this.resources.items.periModel.scene.traverse((child) => {
                if (child.isMesh) {
                    TweenMax.to(child.material.color, {
                        r: 0.419607,
                        g: 0.419607,
                        b: 0.419607
                    })
                    TweenMax.to(child.material, {
                        metalness: 0.35
                    })
                }
            })

            this.batiUrbain.traverse((child) => {
                if (child.isMesh) {
                    // Vérifie si l'enfant est un mesh
                    TweenMax.to(child.material.color, {
                        r: 0.419607,
                        g: 0.419607,
                        b: 0.419607
                    })
                }
            })
            this.resources.items.vehiculeModel.scene.traverse((child) => {
                if (child.isMesh) {
                    // Vérifie si l'enfant est un mesh
                    TweenMax.to(child.material.color, {
                        r: 0.6313,
                        g: 0.6313,
                        b: 0.6313
                    })
                }
            })
        }

        if (this.resources.items.urbainModel) {
            this.resources.items.urbainModel.scene.traverse((child) => {
                if (child.isMesh) {
                    TweenMax.to(child.material.color, {
                        r: 0.419607,
                        g: 0.419607,
                        b: 0.419607
                    })
                    TweenMax.to(child.material, {
                        metalness: 0.35
                    })
                }
            })

            this.batiPeri.traverse((child) => {
                if (child.isMesh) {
                    // Vérifie si l'enfant est un mesh
                    TweenMax.to(child.material.color, {
                        r: 0.419607,
                        g: 0.419607,
                        b: 0.419607
                    })
                }
            })
            this.resources.items.vehiculeUrbain.scene.traverse((child) => {
                if (child.isMesh) {
                    // Vérifie si l'enfant est un mesh
                    TweenMax.to(child.material.color, {
                        r: 0.6313,
                        g: 0.6313,
                        b: 0.6313
                    })
                }
            })
        }

        if (this.resources.items.ruralModel) {
           this.resources.items.ruralModel.scene.traverse((child) => {
                if (child.isMesh) {
                    TweenMax.to(child.material.color, {
                        r: 0.419607,
                        g: 0.419607,
                        b: 0.419607
                    })
                    TweenMax.to(child.material, {
                        metalness: 0.35
                    })
                }
            })
            this.batiRural.traverse((child) => {
                if (child.isMesh) {
                    // Vérifie si l'enfant est un mesh
                    TweenMax.to(child.material.color, {
                        r: 0.419607,
                        g: 0.419607,
                        b: 0.419607
                    })
                }
            })

            this.resources.items.ruralModel.scene.traverse((child) => {
                if (child.isMesh) {
                    TweenMax.to(child.material.color, {
                        r: 0.419607,
                        g: 0.419607,
                        b: 0.419607
                    })
                    TweenMax.to(child.material, {
                        metalness: 0.35
                    })
                }
            })
            this.resources.items.vehiculeRural.scene.traverse((child) => {
                if (child.isMesh) {
                    // Vérifie si l'enfant est un mesh
                    TweenMax.to(child.material.color, {
                        r: 0.6313,
                        g: 0.6313,
                        b: 0.6313
                    })
                }
            })
        }


    }

    setUrbainModel() {
        this.urbainModel = this.resources.items.urbainModel.scene
    }
    setPeriModel() {
        this.periModel = this.resources.items.periModel.scene
    }
    setRuralModel() {
        this.ruralModel = this.resources.items.ruralModel.scene
    }
    setFlecheModel() {
        // console.log(this.resources.items.flecheModel);

    }
    setVehiculePeri() {
        this.vehiculeModel = this.resources.items.vehiculeModel.scene
    }
    setVehiculeRural() {
        // console.log(this.resources.items.vehiculeRural);

        this.vehiculeRuralModel = this.resources.items.vehiculeRural.scene
        this.eolienneModel = this.resources.items.eoliennes.scene
        this.fluxRuralModel = this.resources.items.fluxRural.scene
    }
    setVehicule() {
        // this.vehiculeModel = this.vehicule.scene
        // this.vehiculeRuralModel = this.vehiculeRural.scene
        this.vehiculeUrbainModel = this.resources.items.vehiculeUrbain.scene
        this.fluxUrbainModel = this.resources.items.fluxUrbain.scene


    }



    animFluxUrbain(){
  this.mixerUrb = new THREE.AnimationMixer(this.resources.items.fluxUrbain.scene)


            // console.log(this.mixerUrb);

            for (var item in this.resources.items.fluxUrbain.animations) {
                this.clip = this.resources.items.fluxUrbain.animations[item]
                this.action = this.mixerUrb.clipAction(this.clip)
                this.action.play()
            }
            for (var item in this.resources.items.fluxUrbain.scene.children) {
                this.resources.items.fluxUrbain.scene.children[item].material.color.setHex(
                    0x000000
                )
                this.resources.items.fluxUrbain.scene.children[item].material.emissive.setHex(
                    0xD62246
                )
            }
    }
    animFLuxPeri(){
  this.mixer = new THREE.AnimationMixer(this.resources.items.flecheModel.scene)

            for (var item in this.resources.items.flecheModel.animations) {
                this.clip = this.resources.items.flecheModel.animations[item]
                this.action = this.mixer.clipAction(this.clip)
                this.action.play()
            }

            for (var item in this.resources.items.flecheModel.scene.children) {
                this.resources.items.flecheModel.scene.children[item].material.color.setHex(
                    0x000000
                )
                this.resources.items.flecheModel.scene.children[item].material.emissive.setHex(
                    0xD62246
                )
            }
    }
    animFluxRural(){

            this.mixerRural = new THREE.AnimationMixer(this.resources.items.fluxRural.scene)

            for (var item in this.resources.items.fluxRural.animations) {
                this.clip = this.resources.items.fluxRural.animations[item]
                this.action = this.mixerRural.clipAction(this.clip)
                this.action.play()
            }

            for (var item in this.fluxRuralModel.children) {
                this.fluxRuralModel.children[item].material.color.setHex(
                    0x000000
                )
                this.fluxRuralModel.children[item].material.emissive.setHex(
                    0xD62246
                )
            }
    }
    setAnimationFleche() {

        if (this.resources.items.periModel) {
          
        }

        if (this.resources.items.urbainModel) {
        
        }

        if (this.resources.items.ruralModel) {



        }



        // for (let i = 0; i < 2; i++) {
        //     TweenMax.to(this.chaleurUrbain.children[i].material.emissive, {
        //         r: 1,
        //         g: 0.1803921,
        //         b: 0
        //     })
        // }
    }
    setAnimationVehicule() {
        this.animationsVeh = this.resources.items.vehiculeModel.animations
        this.mixerVeh = new THREE.AnimationMixer(this.resources.items.vehiculeModel.scene)
        this.clipVeh = this.animationsVeh[0]
        this.actionVeh = this.mixerVeh.clipAction(this.clipVeh)
        this.actionVeh.play()
    }
    setAnimationVehiculeUrbain() {
        this.animationsVehUrbain = this.resources.items.vehiculeUrbain.animations
        this.mixerVehUrbain = new THREE.AnimationMixer(this.resources.items.vehiculeUrbain.scene)
        this.clipVehUrbain = this.animationsVehUrbain[0]
        this.actionVehUrbain = this.mixerVehUrbain.clipAction(this.clipVehUrbain)
        this.actionVehUrbain.play()
    }
    setAnimationVehiculeRural() {
        this.animationsVehRural = this.resources.items.vehiculeRural.animations
        this.mixerVehRural = new THREE.AnimationMixer(this.resources.items.vehiculeRural.scene)
        this.clipVehRural = this.animationsVehRural[0]
        this.actionVehRural = this.mixerVehRural.clipAction(this.clipVehRural)
        this.actionVehRural.play()
    }


    setAnimationEolienne() {

        this.animationsEolienne = this.resources.items.eoliennes.animations
        this.mixerEolienne = new THREE.AnimationMixer(this.resources.items.eoliennes.scene)
        this.clipEolienne = this.animationsEolienne[0]
        this.actionEolienne = this.mixerEolienne.clipAction(this.clipEolienne)
        this.actionEolienne.play()
    }

    cls() {
        this.body.style.overflow = "hidden"

        // gsap.to( this.batiRural.getObjectByName("espace-vert-pieton").material,{
        //     opacity: 0,
        // })
        // gsap.to( this.batiRural.getObjectByName("espace-convivial").material,{
        //     opacity: 0,
        // })

        this.legendeFLuxExist = false
        this.setLegendeFlux()
        gsap.to(".legende", {
            opacity: 1,
            display: "inherit",
        })

        // gsap.to(this.space1.material, {
        //     opacity: 0,
        // })
        // gsap.to(this.space2.material, {
        //     opacity: 0,
        // })
        // gsap.to(this.space3.material, {
        //     opacity: 0,
        // })

        this.scene.remove(
            this.chaleurUrbain,
            this.gazUrbain,
            this.elecUrbain,
            this.hydroUrbain,
            this.eauUrbain,
            // this.space1,
            // this.space2,
            // this.space3

        )



        // for (let i = 0; i < this.batiUrbain.children.length; i++) {
        //     TweenMax.fromTo(this.batiUrbain.children[i].material, {
        //         emissiveIntensity: 1
        //     })
        // }
         this.resources.items.periModel?.scene.traverse((child) => {
            if (child.isMesh) {
                TweenMax.to(child.material, {
                    metalness: 1
                })
                TweenMax.to(child.material.color, {
                    r: 0,
                    g: 0,
                    b: 0
                })
            }
        })
       this.resources.items.urbainModel?.scene.traverse((child) => {
            if (child.isMesh) {
                TweenMax.to(child.material, {
                    metalness: 1
                })
                TweenMax.to(child.material.color, {
                    r: 0,
                    g: 0,
                    b: 0
                })
            }
        })
        this.resources.items.vehiculeModel?.scene.traverse((child) => {
            if (child.isMesh) {
                // Vérifie si l'enfant est un mesh
                TweenMax.to(child.material.color, {
                    r: 0,
                    g: 0,
                    b: 0
                })
            }
        })
        this.batiUrbain?.traverse((child) => {
            if (child.isMesh) {
                TweenMax.to(child.material, {
                    metalness: 1
                })
                TweenMax.to(child.material.color, {
                    r: 0,
                    g: 0,
                    b: 0
                })
            }
        })
        this.batiPeri?.traverse((child) => {
            if (child.isMesh) {
                TweenMax.to(child.material, {
                    metalness: 1
                })
                TweenMax.to(child.material.color, {
                    r: 0,
                    g: 0,
                    b: 0
                })
            }
        })

       this.resources.items.ruralModel?.scene.traverse((child) => {
            if (child.isMesh) {
                TweenMax.to(child.material.color, {
                    r: 0,
                    g: 0,
                    b: 0
                })
                TweenMax.to(child.material, {
                    metalness: 1
                })
            }
        })
       this.resources.items.vehiculeRural?.scene.traverse((child) => {
            if (child.isMesh) {
                TweenMax.to(child.material.color, {
                    r: 0,
                    g: 0,
                    b: 0
                })
                TweenMax.to(child.material, {
                    metalness: 1
                })
            }
        })
      this.resources.items.vehiculeUrbain?.scene.traverse((child) => {
            if (child.isMesh) {
                TweenMax.to(child.material.color, {
                    r: 0,
                    g: 0,
                    b: 0
                })
                TweenMax.to(child.material, {
                    metalness: 1
                })
            }
        })
        this.batiRural?.traverse((child) => {
            if (child.isMesh) {
                // Vérifie si l'enfant est un mesh
                TweenMax.to(child.material.color, {
                    r: 0,
                    g: 0,
                    b: 0
                })

            }
        })



       this.resources.items.vehiculeRural?.scene.traverse((child) => {
            if (child.isMesh) {
                TweenMax.to(child.material.color, {
                    r: 0,
                    g: 0,
                    b: 0
                })
                TweenMax.to(child.material, {
                    metalness: 1
                })
            }
        })
        this.canvas.style.pointerEvents = "auto"
        this.scene.remove(this.gouvernanceUrbain, this.gouvernanceRural)
        gsap.to(document.documentElement, {
            scrollTop: 0
        })
        this.batiUrbain?.traverse(function (object) {
            if (object.isMesh) {
                TweenMax.to(object.material.emissive, {
                    r: 1,
                    g: 1,
                    b: 1
                })
            }
        })
        this.batiRural?.traverse(function (object) {
            if (object.isMesh) {
                TweenMax.to(object.material.emissive, {
                    r: 1,
                    g: 1,
                    b: 1
                })
            }
        })


        //     gsap.to( this.batiRural.getObjectByName("espace-convivial").material,{
        //         opacity: 0,
        //         emissive:  '0x640298' 
        //     })

        this.batiPeri?.traverse(function (object) {
            if (object.isMesh) {
                TweenMax.to(object.material.emissive, {
                    r: 1,
                    g: 1,
                    b: 1
                })
            }
        })
        for (let i = this.scene.children.length - 1; i >= 0; i--) {
            const object = this.scene.children[i]
            if (object.name === "indicator") {
                this.scene.remove(object)
            }
        }
    }



    setTransition() {

        select_1_action.addEventListener("click", () => {
            if (this.experience.current == "0") {
                if (this.menuClick[0]) {
                    this.controls.autoRotate = false
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 0 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 0
                    })
                    this.indicFollower = 1
                    this.canvas.style.pointerEvents = "none"
                    this.indicPeri()
                    gsap.to(this.controls.target, {
                        x: -147.17328032236983,
                        y: -13.716754262554419,
                        z: 101.67844342809458,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -332.1747757147225,
                        y: 167.481502852481,
                        z: -3.601837334395441,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })




                    TweenMax.to(
                        this.batiPeri.getObjectByName("Batiment_Mutualise")
                            .material.emissive, {
                        r: 0.8862,
                        g: 0,
                        b: 0.3176
                    }
                    )

                    TweenMax.to(
                        this.batiPeri.getObjectByName("Entrepot_Mutualise").material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )

                    TweenMax.to(
                        this.batiPeri.getObjectByName("Batiment_Logistique")
                            .material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )

                    TweenMax.to(
                        this.batiPeri.getObjectByName("Parking1").material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0

                    }
                    )

                } else {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 100 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 180
                    })

                    this.controls.autoRotate = true
                }
            } else if (this.experience.current == "1") {
                if (this.menuClick[0]) {
                    this.controls.autoRotate = false
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 0 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 0
                    })
                    this.indicFollower = 1
                    this.canvas.style.pointerEvents = "none"
                    gsap.to(this.controls.target, {
                        x: -40.3991442712137,
                        y: 37.751250394336324,
                        z: -107.82039437277317,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -232.47739351551695,
                        y: 493.09564293646633,
                        z: 308.5191322700157,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                    TweenMax.to(
                        this.batiUrbain.getObjectByName("Bat_Batiment_Indus1")
                            .material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )


                    TweenMax.to(
                        this.batiUrbain.getObjectByName(
                            "Bat_Entrepot_Mutualise"
                        ).material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )
                    TweenMax.to(
                        this.batiUrbain.getObjectByName(
                            "Bat_Batiment_Logistique"
                        ).material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117,
                        delay: 0.3
                    }
                    )

                    TweenMax.to(
                        this.batiUrbain.getObjectByName("parking-etage")
                            .material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0
                    }
                    )

                    TweenMax.to(
                        this.batiUrbain.getObjectByName(
                            "Bat_Batiment_Mutualise"
                        ).material.emissive, {
                        r: 0.8862,
                        g: 0,
                        b: 0.3176
                    }
                    )
                    // TweenMax.fromTo(
                    //     this.batiUrbain.getObjectByName(
                    //         "Bat_Batiment_Mutualise"
                    //     ).material,
                    //     1.4, { emissiveIntensity: 3.5 }, {
                    //         emissiveIntensity: 1,
                    //         ease: "Linear.easeNone",
                    //         repeat: -1,
                    //         yoyo: true
                    //     }
                    // )
                    this.indicUrbain()


                } else {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 100 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 180
                    })

                    this.controls.autoRotate = true
                }

            } else if (this.experience.current == "2") {
                if (this.menuClick[0]) {
                    this.controls.autoRotate = false
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 0 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 0
                    })
                    this.indicFollower = 1
                    this.indicRural()
                    this.canvas.style.pointerEvents = "none"
                    gsap.to(this.controls.target, {
                        x: 158.07921564609813,
                        y: -75.45506429403052,
                        z: 161.38551593315967,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 442.2509844870476,
                        y: 442.45871494095286,
                        z: -517.5929248676819,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })

                    TweenMax.to(
                        this.batiRural.getObjectByName("Batiment_Mutualise")
                            .material.emissive, {
                        r: 0.8862,
                        g: 0,
                        b: 0.3176,
                    }
                    )
                    TweenMax.to(
                        this.batiRural.getObjectByName("Entrepot_Mutualise").material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )
                    TweenMax.to(
                        this.batiRural.getObjectByName("Batiment_Logistique")
                            .material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )

                    TweenMax.to(
                        this.batiRural.getObjectByName("Batiment_Industriel1").material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )

                } else {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 100 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 180
                    })

                    this.controls.autoRotate = true
                }
            }
        })

        select_2_action.addEventListener("click", () => {
            if (this.experience.current == "0") {
                if (this.menuClick[1]) {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 0 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 0
                    })
                    this.indicFollower = 2
                    this.canvas.style.pointerEvents = "none"
                    this.indicPeri()

                    this.controls.autoRotate = false
                    gsap.to(this.camera.instance.position, {
                        x: -231.1235435123094,
                        y: 215.9983836666337,
                        z: 147.03580584050795,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                    gsap.to(this.controls.target, {
                        x: -37.197138710234945,
                        y: 26.36136264647306,
                        z: -33.88714015526991,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })



                    TweenMax.to(
                        this.batiPeri.getObjectByName("Borne_Hydrogene")
                            .material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0

                    }
                    )
                    TweenMax.to(
                        this.batiPeri.getObjectByName("Methaniseur")
                            .material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0

                    }
                    )


                    TweenMax.to(
                        this.batiPeri.getObjectByName("Batiment_Classique").material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )

                    // TweenMax.to(
                    //     this.batiPeri.getObjectByName("Batiment_Logistique")
                    //     .material.emissive, {
                    //         r: 1,
                    //         g: 0.4274,
                    //         b: 0.0117
                    //     }
                    // )

                    TweenMax.to(
                        this.batiPeri.getObjectByName("Parking2").material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0
                    }
                    )

                } else {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 100 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 180
                    })

                    this.controls.autoRotate = true
                }
            } else if (this.experience.current == "1") {
                if (this.menuClick[1]) {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 0 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 0
                    })
                    this.indicFollower = 2
                    this.canvas.style.pointerEvents = "none"

                    this.controls.autoRotate = false
                    gsap.to(this.camera.instance.position, {
                        x: -327.5617734895212,
                        y: 142.1617439683785,
                        z: -169.05707610207878,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                    gsap.to(this.controls.target, {
                        x: -71.32866603431317,
                        y: -7.927482670905652,
                        z: -34.44436707769342,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })

                    TweenMax.to(
                        this.batiUrbain.getObjectByName(
                            "Bat_Batiment_Logistique"
                        ).material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117,
                        delay: 0.3
                    }
                    )

                    TweenMax.to(
                        this.batiUrbain.getObjectByName("Bat_Borne_Recharge")
                            .material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0,

                    }
                    )
                    TweenMax.to(
                        this.batiUrbain.getObjectByName(
                            "Bat_Batiment_Indus2"
                        ).material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0,
                    }
                    )

                    TweenMax.to(
                        this.batiUrbain.getObjectByName(
                            "Bat_Batiment_Intermediaire"
                        ).material.emissive, {
                        // r: 1,
                        // g: 0.9333,
                        // b: 0, jaune
                        r: 1,
                        g: 0.4274,
                        b: 0.0117,
                        delay: 0.6
                    }
                    )

                    this.indicUrbain()
                } else {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 100 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 180
                    })

                    this.controls.autoRotate = true
                }
            } else if (this.experience.current == "2") {
                if (this.menuClick[1]) {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 0 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 0
                    })
                    this.indicFollower = 2
                    this.indicRural()

                    this.canvas.style.pointerEvents = "none"

                    this.controls.autoRotate = false
                    gsap.to(this.camera.instance.position, {
                        x: 357.23456005371924,
                        y: 165.8427023112641,
                        z: 343.23285706738574,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                    gsap.to(this.controls.target, {
                        x: -71.328666,
                        y: -7.927483,
                        z: -34.444367,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })

                    TweenMax.to(
                        this.batiRural.getObjectByName("Batiment_Classique")
                            .material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )
                    TweenMax.to(
                        this.batiRural.getObjectByName("Batiment_Electrolyseur")
                            .material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0
                    }
                    )

                    TweenMax.to(
                        this.batiRural.getObjectByName("Bornes_hydrogene")
                            .material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0
                    }
                    )
                    TweenMax.to(
                        this.batiRural.getObjectByName("Batiment_methanyseur")
                            .material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0


                    }
                    )
                    // this.batiRural.getObjectByName("Batiment_Mutualise"),
                    // this.batiRural.getObjectByName("ombrieres_Covoit"),
                    // this.batiRural.getObjectByName("ombrieres_Parking"),
                    // this.batiRural.getObjectByName("Batiment_Logistique"),
                    // this.batiRural.getObjectByName("Batiment_Industriel1"),
                    // this.batiRural.getObjectByName("Entrepot_Mutualise"),
                    // this.batiRural.getObjectByName("Batiment_Classique"),
                    // this.batiRural.getObjectByName("Batiment_Industriel2"),
                    // this.batiRural.getObjectByName("Batiment_methanyseur"),
                    // this.batiRural.getObjectByName("Bornes_hydrogene"),
                    // this.batiRural.getObjectByName("Batiment_Gare"),
                    // this.batiRural.getObjectByName("Port"),
                    // this.batiRural.getObjectByName("Batiment_Industriel3"),




                    TweenMax.to(
                        this.batiRural.getObjectByName("Batiment_Industriel2").material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )


                } else {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 100 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 180
                    })

                    this.controls.autoRotate = true
                }
            }
        })

        select_3_action.addEventListener("click", () => {
            if (this.experience.current == "0") {
                if (this.menuClick[2]) {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 0 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 0
                    })
                    this.indicFollower = 3


                    this.controls.autoRotate = false
                    this.canvas.style.pointerEvents = "none"
                    this.indicPeri()


                    gsap.to(this.controls.target, {
                        x: -20.29409000826027,
                        y: 8.811358768725947,
                        z: -49.6888197772195,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -89.19735568029466,
                        y: 195.63863282801745,
                        z: -204.59298477239986,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })


                    TweenMax.to(
                        this.batiPeri.getObjectByName("Batiment_Mutualise")
                            .material.emissive, {

                        r: 0.8862,
                        g: 0,
                        b: 0.3176
                    }
                    )

                    TweenMax.to(
                        this.batiPeri.getObjectByName("Entrepot_Mutualise").material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )
                    TweenMax.to(
                        this.batiPeri.getObjectByName("Borne_Hydrogene")
                            .material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0

                    }
                    )





                } else {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 100 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 180
                    })

                    this.controls.autoRotate = true
                }
            } else if (this.experience.current == "1") {
                if (this.menuClick[2]) {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 0 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 0
                    })
                    this.indicFollower = 3
                    this.controls.autoRotate = false
                    this.canvas.style.pointerEvents = "none"

                    // TweenMax.fromTo(
                    //     this.batiUrbain.getObjectByName("Bat_Borne_Recharge")
                    //     .material,
                    //     1.4, { emissiveIntensity: 3.5 }, {
                    //         emissiveIntensity: 1,
                    //         ease: "Linear.easeNone",
                    //         repeat: -1,
                    //         yoyo: true
                    //     }
                    // )
                    // TweenMax.fromTo(
                    //     this.batiUrbain.getObjectByName(
                    //         "Bat_Entrepot_Mutualise"
                    //     ).material,
                    //     1.4, { emissiveIntensity: 3.5 }, {
                    //         emissiveIntensity: 1,
                    //         ease: "Linear.easeNone",
                    //         repeat: -1,
                    //         yoyo: true
                    //     }
                    // )
                    // TweenMax.fromTo(
                    //     this.batiUrbain.getObjectByName(
                    //         "Bat_Batiment_Mutualise"
                    //     ).material,
                    //     1.4, { emissiveIntensity: 3.5 }, {
                    //         emissiveIntensity: 1,
                    //         ease: "Linear.easeNone",
                    //         repeat: -1,
                    //         yoyo: true
                    //     }
                    // )
                    // TweenMax.fromTo(
                    //     this.batiUrbain.getObjectByName("Bat_Gare").material,
                    //     1.4, { emissiveIntensity: 3.5 }, {
                    //         emissiveIntensity: 1,
                    //         ease: "Linear.easeNone",
                    //         repeat: -1,
                    //         yoyo: true
                    //     }
                    // )
                    // TweenMax.fromTo(
                    //     this.batiUrbain.getObjectByName("Bat_Port_Partie2")
                    //     .material,
                    //     1.4, { emissiveIntensity: 3.5 }, {
                    //         emissiveIntensity: 1,
                    //         ease: "Linear.easeNone",
                    //         repeat: -1,
                    //         yoyo: true
                    //     }
                    // )
                    // TweenMax.fromTo(
                    //     this.batiUrbain.getObjectByName("port-for-bake")
                    //     .material,
                    //     1.4, { emissiveIntensity: 3.5 }, {
                    //         emissiveIntensity: 1,
                    //         ease: "Linear.easeNone",
                    //         repeat: -1,
                    //         yoyo: true
                    //     }
                    // )

                    gsap.to(this.controls.target, {
                        x: 6.581811359546185,
                        y: 4.16324682770597,
                        z: -96.9401376257985,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -438.8564303022027,
                        y: 426.3679362253281,
                        z: 168.20765983685115,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })

                    TweenMax.to(
                        this.batiUrbain.getObjectByName("Bat_Borne_Recharge")
                            .material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0,

                    }
                    )

                    TweenMax.to(
                        this.batiUrbain.getObjectByName(
                            "Bat_Entrepot_Mutualise"
                        ).material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117,
                        delay: 0.3
                    }
                    )

                    TweenMax.to(
                        this.batiUrbain.getObjectByName(
                            "Bat_Batiment_Mutualise"
                        ).material.emissive, {
                        r: 0.8862,
                        g: 0,
                        b: 0.3176,
                        delay: 0.6
                    }
                    )

                    TweenMax.to(
                        this.batiUrbain.getObjectByName("Bat_Gare").material
                            .emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0,
                        delay: 0.9
                    }
                    )

                    TweenMax.to(
                        this.batiUrbain.getObjectByName("Bat_Port_Partie2")
                            .material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0,
                        delay: 1.2
                    }
                    )

                    TweenMax.to(
                        this.batiUrbain.getObjectByName("port-for-bake")
                            .material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0,
                        delay: 1.5
                    }
                    )
                    this.indicUrbain()
                } else {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 100 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 180
                    })

                    this.controls.autoRotate = true
                }
            } else if (this.experience.current == "2") {
                if (this.menuClick[2]) {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 0 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 0
                    })
                    this.indicFollower = 3
                    this.indicRural()

                    this.controls.autoRotate = false
                    this.canvas.style.pointerEvents = "none"
                    gsap.to(this.controls.target, {
                        x: 38.268022727710715,
                        y: 62.536396643453294,
                        z: -58.63501010385903,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -332.6625730639236,
                        y: 616.923161658369,
                        z: 245.39846982452266,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })


                    TweenMax.to(
                        this.batiRural.getObjectByName("Batiment_Mutualise")
                            .material.emissive, {
                        r: 0.8862,
                        g: 0,
                        b: 0.3176,
                    }
                    )
                    TweenMax.to(
                        this.batiRural.getObjectByName("Bornes_hydrogene")
                            .material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0
                    }
                    )

                    TweenMax.to(
                        this.batiRural.getObjectByName("Mesh029")
                            .material.emissive, {

                        r: 0.7137,
                        g: 1,
                        b: 0
                    }
                    )
                    // console.log(this.batiRural);

                    TweenMax.to(
                        this.batiRural.getObjectByName("Mesh029_1")

                            .material.emissive, {

                        r: 0.7137,
                        g: 1,
                        b: 0
                    }
                    )
                    TweenMax.to(
                        this.batiRural.getObjectByName("Entrepot_Mutualise")

                            .material.emissive, {

                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )

                    TweenMax.to(
                        this.batiRural.getObjectByName("Batiment_Gare")
                            .material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0
                    }
                    )

                } else {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 100 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 180
                    })

                    this.controls.autoRotate = true
                }
            }
        })
        select_4_action.addEventListener("click", () => {
            if (this.experience.current == "0") {
                if (this.menuClick[3]) {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 0 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 0
                    })
                    this.indicFollower = 4

                    this.controls.autoRotate = false
                    this.canvas.style.pointerEvents = "none"
                    this.indicPeri()

                    gsap.to(this.controls.target, {
                        x: -71.328666,
                        y: -7.927483,
                        z: -34.444367,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 77.90708929055515,
                        y: 115.44944734918637,
                        z: -196.1670095623706,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                    TweenMax.to(
                        this.batiPeri.getObjectByName("Batiment_Industriel")
                            .material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )


                    TweenMax.to(
                        this.batiPeri.getObjectByName("Batiment_Mutualise")
                            .material.emissive, {

                        r: 0.8862,
                        g: 0,
                        b: 0.3176
                    }
                    )


                } else {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 100 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 180
                    })

                    this.controls.autoRotate = true
                }
            } else if (this.experience.current == "1") {
                if (this.menuClick[3]) {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 0 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 0
                    })
                    this.indicFollower = 4
                    this.indicUrbain()
                    this.controls.autoRotate = false
                    this.canvas.style.pointerEvents = "none"

                    gsap.to(this.controls.target, {
                        x: 1.38242,
                        y: 2.622932,
                        z: 0.762647,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 39.268128789482745,
                        y: 206.58014821651068,
                        z: -365.9949684717376,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })

                    TweenMax.to(
                        this.batiUrbain.getObjectByName(
                            "Bat_Batiment_Mutualise"
                        ).material.emissive, {
                        r: 0.8862,
                        g: 0,
                        b: 0.3176,
                    }
                    )
                    // TweenMax.fromTo(
                    //     this.batiUrbain.getObjectByName(
                    //         "Bat_Batiment_Mutualise"
                    //     ).material,
                    //     1.4, { emissiveIntensity: 3.5 }, {
                    //         emissiveIntensity: 1,
                    //         ease: "Linear.easeNone",
                    //         repeat: -1,
                    //         yoyo: true
                    //     }
                    // )
                    TweenMax.to(
                        this.batiUrbain.getObjectByName("Bat_Batiment_Indus3")
                            .material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )
                    // TweenMax.fromTo(
                    //     this.batiUrbain.getObjectByName("Bati-to-bake_select")
                    //     .material,
                    //     1.4, { emissiveIntensity: 3.5 }, {
                    //         emissiveIntensity: 1,
                    //         ease: "Linear.easeNone",
                    //         repeat: -1,
                    //         yoyo: true
                    //     }
                    // )
                    this.indicUrbain()
                } else {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 100 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 180
                    })

                    this.controls.autoRotate = true
                }
            } else if (this.experience.current == "2") {
                if (this.menuClick[3]) {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 0 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 0
                    })
                    this.indicFollower = 4
                    this.indicRural()
                    // this.scene.add(
                    //     this.space1, this.space2

                    // )






                    this.controls.autoRotate = false
                    this.canvas.style.pointerEvents = "none"

                    gsap.to(this.controls.target, {
                        x: -64.7950778756486,
                        y: 49.11306386384923,
                        z: 235.21319553796025,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -252.0203451301536,
                        y: 181.78284999457333,
                        z: 51.013056678836165,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })

                    // this.batiRural.getObjectByName("Batiment_Mutualise"),
                    // this.batiRural.getObjectByName("ombrieres_Covoit"),
                    // this.batiRural.getObjectByName("ombrieres_Parking"),
                    // this.batiRural.getObjectByName("Batiment_Logistique"),
                    // this.batiRural.getObjectByName("Batiment_Industriel1"),
                    // this.batiRural.getObjectByName("Entrepot_Mutualise"),
                    // this.batiRural.getObjectByName("Batiment_Classique"),
                    // this.batiRural.getObjectByName("Batiment_Industriel2"),
                    // this.batiRural.getObjectByName("Batiment_methanyseur"),
                    // this.batiRural.getObjectByName("Bornes_hydrogene"),
                    // this.batiRural.getObjectByName("Batiment_Gare"),
                    // this.batiRural.getObjectByName("Port"),
                    // this.batiRural.getObjectByName("Batiment_Industriel3"),


                    // TweenMax.to(
                    //     this.batiRural.getObjectByName("Batiment_Industriel3")
                    //     .material.emissive, {

                    //         r: 1,
                    //         g: 0.4274,
                    //         b: 0.0117
                    //     }

                    // gsap.to(this.space1.material, {
                    //     opacity: 0.5,
                    // })
                    // gsap.to(this.space2.material, {
                    //     opacity: 0.5,
                    // })


                    TweenMax.to(
                        this.batiRural.getObjectByName("Batiment_Industriel3")
                            .material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )

                    TweenMax.to(
                        this.batiRural.getObjectByName("Batiment_Mutualise")
                            .material.emissive, {
                        r: 0.8862,
                        g: 0,
                        b: 0.3176,
                    }
                    )

                } else {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 100 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 180
                    })

                    this.controls.autoRotate = true
                }
            }
        })
        select_5_action.addEventListener("click", () => {
            if (this.experience.current == "0") {
                if (this.menuClick[4]) {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 0 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 0
                    })

                    this.indicFollower = 5
                    this.controls.autoRotate = false
                    this.canvas.style.pointerEvents = "none"
                    this.indicPeri()

                    gsap.to(this.controls.target, {
                        x: -20.29409000826027,
                        y: 8.811358768725947,
                        z: -49.6888197772195,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -89.19735568029466,
                        y: 195.63863282801745,
                        z: -204.59298477239986,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })


                    TweenMax.to(
                        this.batiPeri.getObjectByName("Parking1").material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0

                    }
                    )


                    TweenMax.to(
                        this.batiPeri.getObjectByName("Batiment_Mutualise").material.emissive, {

                        r: 0.8862,
                        g: 0,
                        b: 0.3176
                    }
                    )
                    TweenMax.to(
                        this.batiPeri.getObjectByName("Entrepot_Mutualise").material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )
                    TweenMax.to(
                        this.batiPeri.getObjectByName("Borne_Hydrogene").material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0
                    }
                    )

                } else {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 100 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 180
                    })

                    this.controls.autoRotate = true
                }


            } else if (this.experience.current == "1") {
                if (this.menuClick[4]) {
                    this.cls()
                    gsap.to(".legende", {
                        translateX: 0 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(".clsLegSign", {
                        rotate: 0
                    })

                    gsap.to(this.controls.target, {
                        x: 6.581811359546185,
                        y: 4.16324682770597,
                        z: -96.9401376257985,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -438.8564303022027,
                        y: 426.3679362253281,
                        z: 168.20765983685115,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                    this.indicFollower = 5
                    this.controls.autoRotate = false
                    // this.canvas.style.pointerEvents = "none"
                    TweenMax.to(
                        this.batiUrbain.getObjectByName("parking-etage")
                            .material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0
                    }
                    )

                    TweenMax.to(
                        this.batiUrbain.getObjectByName(
                            "Bat_Batiment_Mutualise"
                        ).material.emissive, {
                        r: 0.8862,
                        g: 0,
                        b: 0.3176
                    }
                    )
                    TweenMax.to(
                        this.batiUrbain.getObjectByName(
                            "Bat_Entrepot_Mutualise"
                        ).material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117,
                        delay: 0.3
                    }
                    )
                    TweenMax.to(
                        this.batiUrbain.getObjectByName("Bat_Borne_Recharge")
                            .material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0,

                    }
                    )
                    this.indicUrbain()

                } else {
                    this.cls()
                    this.controls.autoRotate = true
                }
            } else if (this.experience.current == "2") {
                if (this.menuClick[4]) {
                    this.cls()
                    this.controls.autoRotate = false
                    this.indicFollower = 5
                    this.indicRural()
                    this.canvas.style.pointerEvents = "none"

                    gsap.to(this.controls.target, {
                        x: -100.82682641814353,
                        y: 23.78126108676005,
                        z: -111.13200898091426,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -92.55202484019517,
                        y: 648.5064392341886,
                        z: 126.82882961169966,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"

                        }
                    })
                    TweenMax.to(
                        this.batiRural.getObjectByName("Bornes_hydrogene")
                            .material.emissive, {
                        r: 0.7137,
                        g: 1,
                        b: 0
                    }
                    )
                    TweenMax.to(
                        this.batiRural.getObjectByName("Batiment_Mutualise")
                            .material.emissive, {
                        r: 0.8862,
                        g: 0,
                        b: 0.3176,
                    }
                    )
                    TweenMax.to(
                        this.batiRural.getObjectByName("Entrepot_Mutualise").material.emissive, {
                        r: 1,
                        g: 0.4274,
                        b: 0.0117
                    }
                    )



                } else {
                    this.cls()
                    this.controls.autoRotate = true

                }
            }
        })
        select_6_action.addEventListener("click", () => {

            if (this.experience.current == "0") {

                if (this.menuClick[5]) {

                    this.cls()
                    this.canvas.style.pointerEvents = "none"
                    gsap.to(".legende", {
                        opacity: 0,
                        display: "none",
                    })
                    gsap.to(".navbar", {
                        translateX: -150 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(crossClose, {
                        opacity: 1,
                        display: "flex",
                        duration: 0.7
                    })
                    gsap.to(".player", {
                        opacity: 1,
                        display: "flex",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    this.controls.autoRotate = false
                    this.textPlayerContent.innerHTML = "CHALEUR"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[0].zone[5][0].content
                        })
                    this.clsFlux()
                    this.whitePassage()
                    this.scene.add(this.chaleurPeri)
                    gsap.to(this.controls.target, {
                        x: -46.0883782857517,
                        y: -17.02198245629419,
                        z: -2.1394562105361166,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 115.23129738440554,
                        y: 448.9078502427371,
                        z: 387.606725715988,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else {
                    this.cls()

                    this.controls.autoRotate = true
                }



            } else if (this.experience.current == "1") {
                if (this.menuClick[5]) {
                    this.cls()
                    gsap.to(".legende", {
                        opacity: 0,
                        display: "none",
                    })
                    this.canvas.style.pointerEvents = "none"

                    gsap.to(".navbar", {
                        translateX: -150 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(crossClose, {
                        opacity: 1,
                        display: "flex",
                        duration: 0.7
                    })
                    gsap.to(".player", {
                        opacity: 1,
                        display: "flex",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    this.controls.autoRotate = false
                    this.textPlayerContent.innerHTML = "CHALEUR"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[1].zone[5][0].content
                        })
                    this.clsFlux()
                    this.whitePassage()
                    this.scene.add(this.chaleurUrbain)
                    gsap.to(this.controls.target, {
                        x: 0,
                        y: 0,
                        z: 0,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -16.6518995646558,
                        y: 212.6452558149558,
                        z: 415.31123173056113,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else {
                    this.cls()

                    this.controls.autoRotate = true
                }
            } else if (this.experience.current == "2") {


                if (this.menuClick[5]) {

                    this.cls()
                    this.canvas.style.pointerEvents = "none"
                    gsap.to(".legende", {
                        opacity: 0,
                        display: "none",
                    })
                    gsap.to(".navbar", {
                        translateX: -150 + "%",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })
                    gsap.to(crossClose, {
                        opacity: 1,
                        display: "flex",
                        duration: 0.7
                    })
                    gsap.to(".player", {
                        opacity: 1,
                        display: "flex",
                        ease: "back.out(1.7)",
                        duration: 0.7
                    })

                    this.gazRural.children[0].material.opacity = 1

                    // gsap.to(this.space2.material, {
                    //     opacity: 1,
                    // })

                    this.controls.autoRotate = false


                    this.textPlayerContent.innerHTML = "GAZ"
                    this.whitePassage()
                    this.clsFlux()
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[2].zone[5][0].content
                        })
                    this.scene.add(this.gazRural)
                    this.canvas.style.pointerEvents = "none"

                    gsap.to(this.controls.target, {
                        x: 452.4650716433878,
                        y: -65.470151655675,
                        z: 106.42915870548441,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 455.3048776921378,
                        y: 401.0354788385749,
                        z: 260.9998188292341,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else {
                    this.cls()

                    this.controls.autoRotate = true
                }

            }
        })

        crossClose.addEventListener("click", () => {
            this.cls()
            this.clsFlux()

            this.menuClick[5] = false
            this.actionButton[5].style.background = "#1A2783"
            this.actionButton[5].style.color = "#fff"

            gsap.to(this.crossButton[5], {
                rotate: 0,
                ease: "back.out(1.7)",
                color: "#fff"
            })

            gsap.to(".scroll-box", {
                opacity: 0,
                display: "none",

                duration: 0.7
            })

            gsap.to(".navbar", {
                translateX: 0 + "%",
                ease: "back.out(1.7)",
                duration: 0.7
            })
            gsap.to(".player", {
                opacity: 0,
                display: "none",
                ease: "back.out(1.7)",
                duration: 0.7
            })
            gsap.to(crossClose, {
                opacity: 0,
                display: "none",
                duration: 0.4
            })
            this.controls.enabled = true
            this.controls.autoRotate = true
        })
        playerBack.addEventListener("click", () => {
            if (this.experience.current == "0") {
                gsap.to(playerBack, {
                    translateX: -400 + "px",
                    duration: 0.2
                })
                gsap.to(playerBack, {
                    translateX: 0,
                    duration: 0.2
                })
                this.callPrev()
                if (this.fluxfollower == 1) {
                    this.textPlayerContent.innerHTML = "CHALEUR"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[0].zone[5][0].content
                        })

                    this.scene.add(this.chaleurPeri)
                    gsap.to(this.controls.target, {
                        x: 27.270789458706325,
                        y: -22.882227329915274,
                        z: -3.0205457090549044,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 26.629780149568706,
                        y: 463.3148142457016,
                        z: 300.59105594828645,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 2) {
                    this.textPlayerContent.innerHTML = "GAZ"
                    this.clsFlux()
                    this.scene.add(this.gazPeri)
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[0].zone[5][0].content
                        })
                    gsap.to(this.controls.target, {
                        x: 8.193120848906236,
                        y: -39.634009808671635,
                        z: 36.61604277214285,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 11.505331031020237,
                        y: 504.4751960024626,
                        z: 216.8996532872566,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 3) {
                    this.textPlayerContent.innerHTML = "ELECTRICITE"
                    this.clsFlux()
                    this.scene.add(this.elecPeri)
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[0].zone[5][0].content
                        })
                    gsap.to(this.controls.target, {
                        x: -32.13131324099161,
                        y: -82.98196552587402,
                        z: 79.75959525846575,


                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -125.63268419806067,
                        y: 265.1053541498586,
                        z: 361.15256744280623,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 4) {
                    this.textPlayerContent.innerHTML = "HYDROGENE"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[0].zone[5][0].content
                        })

                    gsap.to(this.camera.instance.position, {
                        x: -207.68158145836213,
                        y: 193.20275624014587,
                        z: 346.3494530936986,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                    gsap.to(this.controls.target, {
                        x: 55.46070783947833,
                        y: -150.08015703488772,
                        z: -8.854373478204742,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    this.scene.add(this.hydroPeri)
                } else if (this.fluxfollower == 5) {
                    this.textPlayerContent.innerHTML = "EAU"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = false
                    this.setLegendeFlux()

                    this.scene.add(this.eauPeri)
                    gsap.to(this.controls.target, {
                        x: -50.989720477646124,
                        y: -71.46183633576378,
                        z: 12.330109358262789,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -314.12381600533865,
                        y: 319.20326035607593,
                        z: 274.0834802028379,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 6) {
                    this.textPlayerContent.innerHTML = "DATA"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[0].zone[5][1].content
                        })
                    this.scene.add(this.dataPeri)
                    gsap.to(this.controls.target, {
                        x: -9.472736005675424,
                        y: -66.2484431830696,
                        z: -6.274134417710711,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -11.30163786508253,
                        y: 454.06440955262264,
                        z: 133.88572908224012,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                }
                else if (this.fluxfollower == 7) {
                    this.textPlayerContent.innerHTML = "GOUVERNANCE"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[0].zone[5][2].content
                        })
                    this.scene.add(this.gouvernancePeri)
                    gsap.to(this.controls.target, {
                        x: 84,
                        y: -78,
                        z: -51,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {


                        x: 84,
                        y: 498,
                        z: 103,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                }

            } else if (this.experience.current == "1") {

                gsap.to(playerBack, {
                    translateX: -400 + "px",
                    duration: 0.2
                })
                gsap.to(playerBack, {
                    translateX: 0,
                    duration: 0.2
                })
                this.callPrev()
                if (this.fluxfollower == 1) {
                    this.textPlayerContent.innerHTML = "CHALEUR"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[1].zone[5][0].content
                        })

                    this.scene.add(this.chaleurUrbain)
                    gsap.to(this.controls.target, {
                        x: 0,
                        y: 0,
                        z: 0,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -16.6518995646558,
                        y: 212.6452558149558,
                        z: 415.31123173056113,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 2) {
                    this.textPlayerContent.innerHTML = "GAZ"
                    this.clsFlux()
                    this.scene.add(this.gazUrbain)
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[1].zone[5][0].content
                        })
                    gsap.to(this.controls.target, {
                        x: 324.8599417054526,
                        y: -19.769214775495318,
                        z: 10.971746174197415,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 303.545836323471,
                        y: 524.3646352742294,
                        z: 189.94671868029988,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 3) {
                    this.textPlayerContent.innerHTML = "ELECTRICITE"
                    this.clsFlux()
                    this.scene.add(this.elecUrbain)
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[1].zone[5][0].content
                        })
                    gsap.to(this.controls.target, {
                        x: 352.9419482743943,
                        y: 107.50169790302513,
                        z: -194.7078271401908,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 387.80334278014413,
                        y: 351.4072472055884,
                        z: 84.59286306645348,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 4) {
                    this.textPlayerContent.innerHTML = "HYDROGENE"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[1].zone[5][0].content
                        })
                    gsap.to(this.camera.instance.position, {
                        x: 243.46980498870246,
                        y: 336.33235044540805,
                        z: 399.76263719083664,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                    gsap.to(this.controls.target, {
                        x: 283.97308873812545,
                        y: -249.18012925510655,
                        z: 113.96367563714061,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    this.scene.add(this.hydroUrbain)
                } else if (this.fluxfollower == 5) {
                    this.textPlayerContent.innerHTML = "EAU"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = false
                    this.setLegendeFlux()

                    this.scene.add(this.eauUrbain)
                    gsap.to(this.controls.target, {
                        x: 39.894517043055515,
                        y: -50.30392760675271,
                        z: 81.44409731644217,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -116.2557714969748,
                        y: 197.85718503199834,
                        z: 207.93823345793868,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                }
                else if (this.fluxfollower == 6) {
                    this.textPlayerContent.innerHTML = "GOUVERNANCE"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[1].zone[5][2].content
                        })
                    this.scene.add(this.gouvernanceUrbain)

                    gsap.to(this.controls.target, {
                        x: 29.45276786841379,
                        y: 15.255312690875526,
                        z: -2.9615493229047556,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -59.55564113151979,
                        y: 508.9157826904418,
                        z: 332.36081067775024,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                }
                else if (this.fluxfollower == 7) {
                    this.textPlayerContent.innerHTML = "DATA"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[0].zone[5][1].content
                        })
                    this.scene.add(this.dataPeri)
                    gsap.to(this.controls.target, {
                        x: 42.331590423376035,
                        y: -27.191675750017733,
                        z: 51.12586684511488,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 21.886953217563054,
                        y: 407.8715160011083,
                        z: 358.92727096305794,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                }
            } else if (this.experience.current == "2") {


                gsap.to(playerBack, {
                    translateX: -400 + "px",
                    duration: 0.2
                })
                gsap.to(playerBack, {
                    translateX: 0,
                    duration: 0.2
                })
                this.callPrev()
                if (this.fluxfollower == 1) {
                    this.textPlayerContent.innerHTML = "GAZ"
                    this.clsFlux()
                    this.scene.add(this.gazRural)
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[2].zone[5][0].content
                        })
                    gsap.to(this.controls.target, {
                        x: 452.4650716433878,
                        y: -65.470151655675,
                        z: 106.42915870548441,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 455.3048776921378,
                        y: 401.0354788385749,
                        z: 260.9998188292341,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 2) {
                    this.textPlayerContent.innerHTML = "ELECTRICITE"
                    this.clsFlux()
                    this.scene.add(this.elecRural)
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[2].zone[5][0].content
                        })
                    gsap.to(this.controls.target, {
                        x: 32.10218656945459,
                        y: -27.79700547055494,
                        z: 98.06070886565621,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {

                        x: 90.85901448550196,
                        y: 541.4907128893191,
                        z: 416.1901678949274,


                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 3) {
                    this.textPlayerContent.innerHTML = "HYDROGENE"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[2].zone[5][0].content
                        })
                    gsap.to(this.camera.instance.position, {
                        x: 391.715165468357,
                        y: 338.9477135147074,
                        z: 433.2877929058135,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                    gsap.to(this.controls.target, {
                        x: 207.91394889636348,
                        y: -245.19132449344966,
                        z: 121.54575119643502,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    this.scene.add(this.hydroRural)
                } else if (this.fluxfollower == 4) {
                    this.textPlayerContent.innerHTML = "EAU"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = false
                    this.setLegendeFlux()
                    this.scene.add(this.eauRural)
                    gsap.to(this.controls.target, {
                        x: 16.83039991990944,
                        y: 124.99318627166171,
                        z: 5.715242201258763,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 17.24280010623018,
                        y: 446.6871730137828,
                        z: 135.1350171381425,

                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                }
                else if (this.fluxfollower == 5) {
                    this.textPlayerContent.innerHTML = "GOUVERNANCE"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[2].zone[5][1].content
                        })

                    this.scene.add(this.gouvernanceRural)
                    gsap.to(this.controls.target, {
                        x: 16.83039991990944,
                        y: 124.99318627166171,
                        z: 5.715242201258763,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 17.24280010623018,
                        y: 446.6871730137828,
                        z: 135.1350171381425,

                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                }
            }
        })

        playerNext.addEventListener("click", () => {
            if (this.experience.current == "0") {
                gsap.to(playerNext, {
                    translateX: 400 + "px",
                    duration: 0.2
                })
                gsap.to(playerNext, {
                    translateX: 0,
                    duration: 0.2
                })
                this.callNext()
                if (this.fluxfollower == 1) {
                    this.textPlayerContent.innerHTML = "CHALEUR"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[0].zone[5][0].content
                        })

                    this.scene.add(this.chaleurPeri)
                    gsap.to(this.controls.target, {
                        x: 27.270789458706325,
                        y: -22.882227329915274,
                        z: -3.0205457090549044,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 26.629780149568706,
                        y: 463.3148142457016,
                        z: 300.59105594828645,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 2) {
                    this.textPlayerContent.innerHTML = "GAZ"
                    this.clsFlux()
                    this.scene.add(this.gazPeri)
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[0].zone[5][0].content
                        })
                    gsap.to(this.controls.target, {
                        x: 8.193120848906236,
                        y: -39.634009808671635,
                        z: 36.61604277214285,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 11.505331031020237,
                        y: 504.4751960024626,
                        z: 216.8996532872566,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 3) {
                    this.textPlayerContent.innerHTML = "ELECTRICITE"
                    this.clsFlux()
                    this.scene.add(this.elecPeri)
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[0].zone[5][0].content
                        })
                    gsap.to(this.controls.target, {
                        x: -32.13131324099161,
                        y: -82.98196552587402,
                        z: 79.75959525846575,


                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -125.63268419806067,
                        y: 265.1053541498586,
                        z: 361.15256744280623,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 4) {
                    this.textPlayerContent.innerHTML = "HYDROGENE"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[0].zone[5][0].content
                        })

                    gsap.to(this.camera.instance.position, {
                        x: -207.68158145836213,
                        y: 193.20275624014587,
                        z: 346.3494530936986,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                    gsap.to(this.controls.target, {
                        x: 55.46070783947833,
                        y: -150.08015703488772,
                        z: -8.854373478204742,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    this.scene.add(this.hydroPeri)
                } else if (this.fluxfollower == 5) {
                    this.textPlayerContent.innerHTML = "EAU"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = false
                    this.setLegendeFlux()

                    this.scene.add(this.eauPeri)
                    gsap.to(this.controls.target, {
                        x: -50.989720477646124,
                        y: -71.46183633576378,
                        z: 12.330109358262789,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -314.12381600533865,
                        y: 319.20326035607593,
                        z: 274.0834802028379,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 6) {
                    this.textPlayerContent.innerHTML = "DATA"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[0].zone[5][1].content
                        })
                    this.scene.add(this.dataPeri)
                    gsap.to(this.controls.target, {
                        x: -9.472736005675424,
                        y: -66.2484431830696,
                        z: -6.274134417710711,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -11.30163786508253,
                        y: 454.06440955262264,
                        z: 133.88572908224012,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                }
                else if (this.fluxfollower == 7) {
                    this.textPlayerContent.innerHTML = "GOUVERNANCE"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[0].zone[5][2].content
                        })
                    this.scene.add(this.gouvernancePeri)
                    gsap.to(this.controls.target, {
                        x: 84,
                        y: -78,
                        z: -51,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 84,
                        y: 498,
                        z: 103,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                }

            } else if (this.experience.current == "1") {
                gsap.to(playerNext, {
                    translateX: 400 + "px",
                    duration: 0.2
                })
                gsap.to(playerNext, {
                    translateX: 0,
                    duration: 0.2
                })
                this.callNext()
                if (this.fluxfollower == 1) {
                    this.textPlayerContent.innerHTML = "CHALEUR"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[1].zone[5][0].content
                        })


                    this.scene.add(this.chaleurUrbain)
                    gsap.to(this.controls.target, {
                        x: 0,
                        y: 0,
                        z: 0,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -16.6518995646558,
                        y: 212.6452558149558,
                        z: 415.31123173056113,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 2) {
                    this.textPlayerContent.innerHTML = "GAZ"
                    this.clsFlux()
                    this.scene.add(this.gazUrbain)
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[1].zone[5][0].content
                        })

                    gsap.to(this.controls.target, {
                        x: 324.8599417054526,
                        y: -19.769214775495318,
                        z: 10.971746174197415,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 303.545836323471,
                        y: 524.3646352742294,
                        z: 189.94671868029988,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 3) {
                    this.textPlayerContent.innerHTML = "ELECTRICITE"
                    this.clsFlux()
                    this.scene.add(this.elecUrbain)
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[1].zone[5][0].content
                        })

                    gsap.to(this.controls.target, {
                        x: 352.9419482743943,
                        y: 107.50169790302513,
                        z: -194.7078271401908,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 387.80334278014413,
                        y: 351.4072472055884,
                        z: 84.59286306645348,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 4) {
                    this.textPlayerContent.innerHTML = "HYDROGENE"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[1].zone[5][0].content
                        })
                    gsap.to(this.camera.instance.position, {
                        x: 243.46980498870246,
                        y: 336.33235044540805,
                        z: 399.76263719083664,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                    gsap.to(this.controls.target, {
                        x: 283.97308873812545,
                        y: -249.18012925510655,
                        z: 113.96367563714061,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    this.scene.add(this.hydroUrbain)
                } else if (this.fluxfollower == 5) {
                    this.textPlayerContent.innerHTML = "EAU"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = false
                    this.setLegendeFlux()

                    this.scene.add(this.eauUrbain)
                    gsap.to(this.controls.target, {
                        x: 39.894517043055515,
                        y: -50.30392760675271,
                        z: 81.44409731644217,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -116.2557714969748,
                        y: 197.85718503199834,
                        z: 207.93823345793868,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                }
                else if (this.fluxfollower == 6) {
                    this.textPlayerContent.innerHTML = "GOUVERNANCE"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[1].zone[5][2].content
                        })
                    this.scene.add(this.gouvernanceUrbain)

                    gsap.to(this.controls.target, {
                        x: 29.45276786841379,
                        y: 15.255312690875526,
                        z: -2.9615493229047556,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: -59.55564113151979,
                        y: 508.9157826904418,
                        z: 332.36081067775024,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                }
                else if (this.fluxfollower == 7) {
                    this.textPlayerContent.innerHTML = "DATA"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[0].zone[5][1].content
                        })
                    this.scene.add(this.dataPeri)
                    gsap.to(this.controls.target, {
                        x: 42.331590423376035,
                        y: -27.191675750017733,
                        z: 51.12586684511488,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 21.886953217563054,
                        y: 407.8715160011083,
                        z: 358.92727096305794,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                }
            } else if (this.experience.current == "2") {
                gsap.to(playerNext, {
                    translateX: 400 + "px",
                    duration: 0.2
                })
                gsap.to(playerNext, {
                    translateX: 0,
                    duration: 0.2
                })
                this.callNext()
                if (this.fluxfollower == 1) {
                    this.textPlayerContent.innerHTML = "GAZ"
                    this.clsFlux()
                    this.scene.add(this.gazRural)
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[2].zone[5][0].content
                        })
                    gsap.to(this.controls.target, {
                        x: 452.4650716433878,
                        y: -65.470151655675,
                        z: 106.42915870548441,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 455.3048776921378,
                        y: 401.0354788385749,
                        z: 260.9998188292341,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 2) {
                    this.textPlayerContent.innerHTML = "ELECTRICITE"
                    this.clsFlux()
                    this.scene.add(this.elecRural)
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[2].zone[5][0].content
                        })
                    gsap.to(this.controls.target, {
                        x: 32.10218656945459,
                        y: -27.79700547055494,
                        z: 98.06070886565621,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {

                        x: 90.85901448550196,
                        y: 541.4907128893191,
                        z: 416.1901678949274,


                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                } else if (this.fluxfollower == 3) {
                    this.textPlayerContent.innerHTML = "HYDROGENE"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[2].zone[5][0].content
                        })
                    gsap.to(this.camera.instance.position, {
                        x: 391.715165468357,
                        y: 338.9477135147074,
                        z: 433.2877929058135,
                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                    gsap.to(this.controls.target, {
                        x: 207.91394889636348,
                        y: -245.19132449344966,
                        z: 121.54575119643502,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    this.scene.add(this.hydroRural)
                } else if (this.fluxfollower == 4) {
                    this.textPlayerContent.innerHTML = "EAU"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = false
                    this.setLegendeFlux()

                    this.scene.add(this.eauRural)
                    gsap.to(this.controls.target, {
                        x: 16.83039991990944,
                        y: 124.99318627166171,
                        z: 5.715242201258763,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 17.24280010623018,
                        y: 446.6871730137828,
                        z: 135.1350171381425,

                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                }
                else if (this.fluxfollower == 5) {
                    this.textPlayerContent.innerHTML = "GOUVERNANCE"
                    this.clsFlux()
                    this.canvas.style.pointerEvents = "none"
                    this.legendeFLuxExist = true
                    this.setLegendeFlux()
                    fetch(Data)
                        .then((response) => response.json())
                        .then((data) => {
                            this.fluxContent.innerHTML = data.model[2].zone[5][1].content
                        })

                    this.scene.add(this.gouvernanceRural)
                    gsap.to(this.controls.target, {
                        x: 16.83039991990944,
                        y: 124.99318627166171,
                        z: 5.715242201258763,
                        ease: "Power4.easeInOut",
                        duration: 3
                    })
                    gsap.to(this.camera.instance.position, {
                        x: 17.24280010623018,
                        y: 446.6871730137828,
                        z: 135.1350171381425,

                        ease: "Power4.easeInOut",
                        duration: 3,
                        onComplete: () => {
                            this.canvas.style.pointerEvents = "auto"
                        }
                    })
                }
            }
        })
    }
    clsFlux() {
        this.scene.remove(
            this.chaleurUrbain,
            this.gazUrbain,
            this.elecUrbain,
            this.hydroUrbain,
            this.eauUrbain,
            this.chaleurPeri,
            this.gazPeri,
            this.elecPeri,
            this.hydroPeri,
            this.eauPeri,
            this.spacesPeri,
            this.dataPeri,
            this.gazRural,
            this.elecRural,
            this.eauRural,
            this.hydroRural,
            this.gouvernanceRural,
            this.gouvernancePeri,
            this.gouvernanceUrbain,
            this.gouvernanceRural
        )
    }
    callNext() {
        if (this.experience.current == "0") {
            if (this.fluxfollower >= 7) {
                this.fluxfollower = 1
            } else {
                this.fluxfollower = this.fluxfollower + 1
            }
        } else if (this.experience.current == "1") {
            if (this.fluxfollower >= 7) {
                this.fluxfollower = 1
            } else {
                this.fluxfollower = this.fluxfollower + 1
            }
        } else if (this.experience.current == "2") {
            if (this.fluxfollower >= 5) {
                this.fluxfollower = 1
            } else {
                this.fluxfollower = this.fluxfollower + 1
            }
        }
    }

    callPrev() {
        if (this.experience.current == "0") {
            if (this.fluxfollower <= 1) {
                this.fluxfollower = 7
            } else {
                this.fluxfollower = this.fluxfollower - 1
            }
        } else if (this.experience.current == "1") {
            if (this.fluxfollower <= 1) {
                this.fluxfollower = 7
            } else {
                this.fluxfollower = this.fluxfollower - 1
            }
        } else if (this.experience.current == "2") {
            if (this.fluxfollower <= 1) {
                this.fluxfollower = 5
            } else {
                this.fluxfollower = this.fluxfollower - 1
            }
        }
    }

    update() {
        this.bubble.style.transform = `translate(${this.cursor.x}px, ${this.cursor.y}px)`
        this.bubble.style.left = -this.bubble.clientWidth / 2 + "px"
// console.log(this.mixerUrb);

        if (this.resources.items.periModel) {

            this.mixer.update(this.time.delta * 0.001)
            this.mixerVeh.update(this.time.delta * 0.001)

        }
        // console.log(this.resources.items);
                    this.mixerUrb.update(this.time.delta * 0.001)
console.log(this.mixerUrb);

        if (this.resources.items.urbainModel) {
            this.mixerVehUrbain.update(this.time.delta * 0.001)
        }
        if (this.resources.items.ruralModel) {
            this.mixerRural.update(this.time.delta * 0.001)
            this.mixerVehRural.update(this.time.delta * 0.001)
            this.mixerEolienne.update(this.time.delta * 0.001)

        }


        const cameraPosition = new THREE.Vector3()
        this.camera.instance.getWorldPosition(cameraPosition)

        // // Récupération de la position du modèle 3D
        // const modelPosition = this.chaleurUrbain.rotation.clone()

        // // Calcul de la direction de la caméra par rapport au modèle 3D
        // const lookAtVector = cameraPosition.clone().sub(modelPosition)
        //     // Mise à jour de la rotation du modèle 3D
        // this.chaleurUrbain.quaternion.setFromUnitVectors(
        //     new THREE.Vector3(0, 0, 1),
        //     lookAtVector.clone().normalize()
        // )
    }
}